unit ManualEntryList2;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.WebCtrls,
  XData.Web.Client,
  smx.webcore.types, WEBLib.Country, WEBLib.EditAutocomplete, WEBLib.DropDown,
  Vcl.Mask, WEBLib.Mask, SMX.Web.Utils, GA.Return.Types;

type
  TManualEntryListForm2 = class(TBaseListForm)
    RefreshTimer: TTimer;
    WaitForBatchIdTimer: TTimer;
    MergeButton: TButton;
    WaitForBatchDataTimer: TTimer;
    DonationsData: TLabel;
    ClearButton: TButton;
    NextRecordTimer: TTimer;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetTitle: TStringField;
    MainDatasetFirstName: TStringField;
    MainDatasetMiddleName: TStringField;
    MainDatasetLastName: TStringField;
    MainDatasetSuffix: TStringField;
    MainDatasetAdd1: TStringField;
    MainDatasetAdd2: TStringField;
    MainDatasetAdd3: TStringField;
    MainDatasetCity: TStringField;
    MainDatasetPostCode: TStringField;
    MainDatasetEmail: TStringField;
    MainDatasetMobile: TStringField;
    MainDatasetTelephone: TStringField;
    MainDatasetMatchHash: TStringField;
    MainDatasetContactByPhone: TBooleanField;
    MainDatasetContactedByPost: TBooleanField;
    MainDatasetContactByText: TBooleanField;
    MainDatasetContactByEmail: TBooleanField;
    MainDatasetDOB: TDateField;
    MainDatasetHearingStatus: TStringField;
    MainDatasetEmailStatus: TStringField;
    MainDatasetLatitude: TFloatField;
    MainDatasetLongitude: TFloatField;
    MainDatasetExternalId: TStringField;
    MainDatasetCountryCode: TStringField;
    MainDatasetVisualStatus: TStringField;
    MainDatasetMobilityStatus: TStringField;
    MainDatasetSourceType: TStringField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetImportState: TStringField;
    MainDatasetErrorText: TStringField;
    MainDatasetImportBatchId: TIntegerField;
    MainDatasetSponsored: TBooleanField;
    MainDatasetDonationDate: TDateTimeField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetExternalDonationId: TStringField;
    MainDatasetMatchedPerson: TIntegerField;
    MainDatasetExternalDonationKind: TStringField;
    MainDatasetExternalDonorKind: TStringField;
    MainDatasetPaymentMethod: TStringField;
    MainDatasetPaymentMethodNote: TStringField;
    MainDatasetOtherDonationKind: TStringField;
    MainDatasetBankingDate: TDateTimeField;
    MainDatasetDonorResidence: TStringField;
    MainDatasetOrganisationName: TStringField;
    MainDatasetDonationClaimStatus: TStringField;
    MainDatasetComment: TStringField;
    MainDatasetAnalysisCode1: TStringField;
    MainDatasetAnalysisCode2: TStringField;
    MainDatasetAnalysisCode3: TStringField;

    MainDatasetBankingReference: TStringField;
    MainDatasetBankingReference2: TStringField;

    MainDatasetDeclarationDateSigned: TDateTimeField;
    MainDatasetDeclarationDateStarted: TDateTimeField;
    MainDatasetDeclarationClaimCoverage: TStringField;

    MainDatasetDeclarationMethod: TStringField;
    MainDatasetDeclarationStatus: TStringField;
    MainDatasetDeclarationId: TIntegerField;

    DonorsDatasetId: TIntegerField;
    DonorsDatasetDateAdded: TDateTimeField;
    DonorsDatasetAddedBy: TIntegerField;
    DonorsDatasetLastUpdatedBy: TIntegerField;
    DonorsDatasetLastUpdated: TDateTimeField;
    DonorsDatasetTitle: TStringField;
    DonorsDatasetFirstName: TStringField;
    DonorsDatasetMiddleName: TStringField;
    DonorsDatasetLastName: TStringField;
    DonorsDatasetSuffix: TStringField;
    DonorsDatasetAdd1: TStringField;
    DonorsDatasetAdd2: TStringField;
    DonorsDatasetAdd3: TStringField;
    DonorsDatasetCity: TStringField;
    DonorsDatasetPostCode: TStringField;
    DonorsDatasetEmail: TStringField;
    DonorsDatasetMobile: TStringField;
    DonorsDatasetTelephone: TStringField;
    DonorsDatasetMatchHash: TStringField;
    DonorsDatasetContactByPhone: TBooleanField;
    DonorsDatasetContactByPost: TBooleanField;
    DonorsDatasetContactByText: TBooleanField;
    DonorsDatasetContactByEmail: TBooleanField;
    DonorsDatasetDOB: TDateField;
    DonorsDatasetHearingStatus: TStringField;
    DonorsDatasetEmailStatus: TStringField;
    DonorsDatasetLatitude: TFloatField;
    DonorsDatasetLongitude: TFloatField;
    DonorsDatasetExternalId: TStringField;
    DonorsDatasetCountryCode: TStringField;
    DonorsDatasetVisualStatus: TStringField;
    DonorsDatasetMobilityStatus: TStringField;
    DonorsDatasetSourceType: TStringField;
    DonorsDatasetClaimStatus: TStringField;
    DonorsDatasetCharityTenant: TStringField;
    DonorsDatasetSponsored: TBooleanField;
    DonorsDatasetMatchedPerson: TIntegerField;
    DonorsDatasetExternalDonationKind: TStringField;
    DonorsDatasetExternalDonorKind: TStringField;
    DonorsDatasetPaymentMethod: TStringField;
    DonorsDatasetPaymentMethodNote: TStringField;
    DonorsDatasetOtherDonationKind: TStringField;
    DonorsDatasetDonorResidence: TStringField;
    DonorsDatasetBankingDate: TDateTimeField;
    DonorsDatasetOrganisationName: TStringField;
    DonorsDatasetDateOfDeath: TDateTimeField;
    MessageDialog: TMessageDlg;
    DuplicateDialog: TMessageDlg;
    CountryList: TCountryComboBox;
    ErrorMessageTransactionDate: TLabel;
    EnableSaveButtonTimer: TTimer;
    DeleteDonation: TMessageDlg;
    DeleteDonor: TMessageDlg;
    DonorsDataset: TXDataWebDataSet;
    SearchDonorsDELETE: TTimer;
    DonorSearchCombo: TComboBox;
    TitleEdit: TEdit;
    FirstNameEdit: TEdit;
    LastNameEdit: TEdit;
    Add1Edit: TEdit;
    Add2Edit: TEdit;
    Add3Edit: TEdit;
    CityEdit: TEdit;
    PostCodeEdit: TEdit;
    AmountEdit: TEdit;
    DonationDateEdit: TDateTimePicker;
    SponsoredEdit: TCheckBox;
    ImportDataDataSource: TDataSource;
    DonationKindCombo: TLookupComboBox;
    OtherDonationKindEdit: TEdit;
    DonorKindCombo: TLookupComboBox;
    PaymentMethodNoteEdit: TEdit;
    DonorClaimStatusCombo: TLookupComboBox;
    OrganisationNameEdit: TEdit;
    PaymentMethodCombo: TLookupComboBox;
    DonationDefaults: TXDataWebDataSet;
    DonationDefaultsId: TIntegerField;
    DonationDefaultsDateAdded: TDateTimeField;
    DonationDefaultsAddedBy: TIntegerField;
    DonationDefaultsLastUpdatedBy: TIntegerField;
    DonationDefaultsLastUpdated: TDateTimeField;
    DonationDefaultsDonorId: TIntegerField;
    DonationDefaultsDonationKind: TStringField;
    DonationDefaultsUsualDayOfMonth: TIntegerField;
    DonationDefaultsAmount: TFloatField;
    DonationDefaultsPaymentMethod: TStringField;
    DonationDefaultsAnalysisCode1: TStringField;
    DonationDefaultsAnalysisCode2: TStringField;
    DonationDefaultsAnalysisCode3: TStringField;
    DonationDefaultsBankingReference: TStringField;
    DonationDefaultsOtherDonationKind: TStringField;

    DeclarationCombo: TComboBox;
    DonationClaimStatus: TLookupComboBox;
    BankingDateEdit: TDateTimePicker;
    CommentMemo: TMemo;
    lbBatchTotal: TLabel;
    AnalysisCode1Combo: TDBComboBox;
    AnalysisCode2Combo: TDBComboBox;
    LookupsDataset: TXDataWebDataSet;
    AnalysisCode1: TStringField;
    AnalysisCode2: TStringField;
    LookupsDataSource: TDataSource;
    DonorDeclarationButton: TButton;
    BankingReference2Edit: TEdit;
    BankingReferenceCombo: TDBComboBox;
    LookupsDatasetBankingReference: TStringField;
    procedure AddButtonClick(Sender: TObject);
    procedure AmountEditDBKeyPress(Sender: TObject; var Key: Char);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure MergeButtonClick(Sender: TObject);
    procedure RefreshTimerTimer(Sender: TObject);
    procedure SaveDonationClick(Sender: TObject);
    procedure WaitForBatchDataTimerTimer(Sender: TObject);
    procedure WaitForBatchIdTimerTimer(Sender: TObject);
    procedure ClearButtonClick(Sender: TObject);
    procedure DateAddedEditDBChange(Sender: TObject);
    procedure MainDatasetAfterDelete(DataSet: TDataSet);
    procedure NextRecordTimerTimer(Sender: TObject);
    procedure PostCodeEditExit(Sender: TObject);
    procedure EditExit(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure EnableSaveButtonTimerTimer(Sender: TObject);
//    procedure SearchDonorsDELETETimer(Sender: TObject);
    procedure FirstNameEditDBChange(Sender: TObject);
//    procedure LoadDonorsTimer(Sender: TObject);
    procedure FullNameEditSelect(Sender: TObject;
      Args: TEditAutoCompleteSelectEventArgs);
    procedure DonorsDatasetAfterOpen(DataSet: TDataSet);
    procedure DonorSearchComboChange(Sender: TObject);
    procedure DonorSearchComboClick(Sender: TObject);
    procedure DonationKindComboChange(Sender: TObject);
    procedure DonationKindComboExit(Sender: TObject);
    procedure ValidateChange(Sender: TObject);
    procedure PostCodeEditChange(Sender: TObject);
    procedure PaymentMethodComboChange(Sender: TObject);
    procedure PaymentMethodComboExit(Sender: TObject);
    procedure DonationDateEditChange(Sender: TObject);
    procedure CountryListChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure LookupsDatasetAfterOpen(DataSet: TDataSet);
    procedure DonorDeclarationButtonClick(Sender: TObject);
    procedure DonorClaimStatusComboChange(Sender: TObject);
    procedure MainDatasetAmountGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure AmountEditKeyPress(Sender: TObject; var Key: Char);
    procedure BankingReferenceComboChange(Sender: TObject);
  private
    { Private declarations }
    FDonorId: integer;
    FDateTimePrevious: TDateTime;

    FBatchId: Integer;
    FBatchTotal: Currency;
    FNoOfDonations: Integer;
    FNoOfErrors: Integer;
    FMergeEnabled: boolean;

    FPostCodeValid: boolean;
    FDonationDateValid: boolean;
    FBankingDateValid: boolean;
    FNonUkCountry: boolean;
    FIsDuplicate: boolean;

    FNewDonorDeclarationDateSigned: TDate;
    FNewDonorDeclarationStatus: string;
    FNewDonorDeclarationCoverage: string;
    FNewDonorDeclarationMethod: string;
    FNewDonorDeclarationOpening: Boolean;
    FDeclarationId: integer;
    FDateOfDeath: TDate;

    [async]
    procedure RefreshData; async;
    [async]
    procedure GetNewBatchId; async;
    [async]
    procedure RefreshBatchData; async;

    procedure SaveNewDonation;
    procedure SaveNewDonationWithBatchId;
    [async]
    procedure MergeDataJob; async;
    procedure ValidatePostCode;
    procedure UnLockControls(const AUnLock: Boolean);override;

    [async]
    procedure CheckForDuplicates; async;
    procedure ValidateDate;
    [async]
    procedure CheckForOpenManualBatches; async;

    //[async]
    //procedure PopulateFromAutoSearch(AIndex: integer);


    procedure LoadDonors;
    procedure SetDonor;
    function TryGetSelectedDonorId(out ADonorId: integer): Boolean;

    procedure LoadDonorData;
    procedure SaveDonationData;
    procedure ClearData;
    procedure RefreshValidation;
    procedure EditDonation(ARecordId: integer);
    procedure SetLookups;
    procedure LoadDefaults(ADonorId: integer);
    procedure SortDonationDate(ADayOfMonth: integer; var ADonationDate: TDate);
    procedure ValidateDonation;
    procedure SetDonorKind;
    [async]
    procedure GetDeclaration(ADonorId: integer); async;
    procedure UpdateBatchAmountLabel;
    procedure BlankEditBox(AEditBox: TEdit);
    [async]
    procedure ShowDeclarations; async;
    [async]
    procedure AddDeclarationForNewDonor; async;
    procedure ApplyNewDonorDeclaration;
    procedure AddNoDeclarationOptions;
    procedure SetDonationClaimStatusLookUpsForDonorClaimStatus(ADonorClaimStatus: string);
    procedure SetDonationClaimStatusBasedOnDonationKind;
    procedure AutoRegisterNonDataAwareRequiredFieldControls;

    //[async]
    //KSS procedure DonationClaimStatusRule(AValidation: boolean);
    procedure CheckDeclarationFornewDonor(AValidation: boolean);
    procedure CheckDeclaration(AValidation: boolean);

  protected
    procedure DeleteSelectedRecord(RecordId: integer);
    procedure EditSelectedRecord(RecordId: integer);
    procedure LoadData; override;
    function CreateGridInFormCreate: Boolean; override;

    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;

    procedure SetDateAddedValidation(bValid: boolean);
    procedure InitialiseFieldMessages;
    procedure SetCountryCode;
    procedure SetCountry;
    procedure SetCountryFromCountryCode(ACountryCode: string);
    procedure SearchData(const AValue: string);
  public
    { Public declarations }
    procedure BindDomHandlers;
    procedure ViewData(const ARecordId: string);
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
    function GetEditFormClass: TFormClass; override;
  protected procedure LoadDFMValues; override; end;

var
  ManualEntryListForm: TManualEntryListForm2;

implementation

{$R *.dfm}

uses
  SMX.Web.Layout.Utils,
  MainDataModule,
  SMX.Web.Service.Consts,
  SMX.CRM.Utils,
  SMX.Web.Document.Utils,
  GA.Web.Utils,
  System.DateUtils,
  DonorDeclaration,
  DonorDeclarationNewDonor,
  Essentials.Web.Shared,
{$IFDEF PAS2JS}
  Generics.Collections,
{$ELSE}
  System.Generics.Collections,
{$ENDIF}
  GA.Rules,
  Essentials.RequiredFields.UtilityUnit;

const
  NO_ACTIVE_GIFT_AID = 6;


procedure TManualEntryListForm2.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
begin
end;

function TManualEntryListForm2.GetEditFormClass: TFormClass;
begin
end;

procedure TManualEntryListForm2.ViewData(const ARecordId: string);
begin
  FBatchId := 0;
  LoadData;
  RefreshTimer.Enabled := false;
end;

procedure TManualEntryListForm2.AddButtonClick(Sender: TObject);
begin
  inherited;
  // EntitySetMappings will be retrieved from EssentialsManager (stored during FormSetUp)
  if TRequiredFieldsUtils.ValidateAndShowMessage(Self) then
    SaveNewDonation;
end;

procedure TManualEntryListForm2.AmountEditDBKeyPress(Sender: TObject; var Key:
    Char);
begin
  if (not (Key in ['0'..'9','.'])) or ((Key = '.') and (Pos('.', AmountEdit.text) > 0)) then
  begin
    TDocUtils.setControlValidity('AmountEdit', vsInvalid);
    Key := #0;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountEdit', vsValid);
  end;
end;

procedure TManualEntryListForm2.AmountEditKeyPress(Sender: TObject;
  var Key: Char);
var
  lDPPos: integer;
  lLen: integer;

begin
  lDPPos := Pos('.', AmountEdit.Text);
  lLen := Length(AmountEdit.Text);

  if ((lDPPos > 0) and (Key = '.')) or ( ((lDPPos+2) = (lLen)) AND (lDPPos <> 0) ) then
  begin
    Key := #0;
    exit;
  end;

  if (not (Key in ['0'..'9','.']) or (Length(TEdit(Sender).Text) > 7)) then
  begin
    TDocUtils.setControlValidity('AmountEdit', vsInvalid);
    Key := #0;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountEdit', vsValid);
  end;
end;

procedure TManualEntryListForm2.LookupsDatasetAfterOpen(DataSet: TDataSet);
begin
  inherited;
  LookupsDataset.Edit;
end;

procedure TManualEntryListForm2.DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField;
  AValue: string; AElement: TJSHTMLElementRecord);
var
  RecordId: integer;
  Span: THTMLSpan;

  procedure EditClick(Sender: TObject);
  begin
    EditSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;


begin
  if ARow = 0 then
    Exit;

  if DataTable.Columns[ACol].Title = 'Donor' then
  begin
    if MainDataset.FieldByName('DonorKind').AsString = 'Individual' then
    begin
      DataTable.Cells[ACol, ARow] := MainDataset.FieldByName('Title').AsString + ' ' +
        MainDataset.FieldByName('FirstName').AsString + ' ' + MainDataset.FieldByName('LastName').AsString;
    end
    else
    begin
      DataTable.Cells[ACol, ARow] := MainDataset.FieldByName('OrganisationName').AsString;
    end;
  end;

  if DataTable.Columns[ACol].Title = 'Address' then
  begin
    DataTable.Cells[ACol, ARow] := MainDataset.FieldByName('Add1').AsString + ' ' +
      MainDataset.FieldByName('City').AsString;
  end;


  if DataTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := MainDataSet.FieldByName('Id').AsInteger;

    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-edit', 'Edit');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @EditClick;

    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-trash', 'Delete');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @DeleteClick;
  end;

end;

procedure TManualEntryListForm2.DeleteSelectedRecord(RecordId: integer);
begin
  if MainDataSet.Locate('Id', RecordId, []) then
  begin
    try
      MainDataSet.Delete;
    finally

    end;
  end;
end;

procedure TManualEntryListForm2.EditSelectedRecord(RecordId: integer);
begin
  if MainDataSet.Locate('Id', RecordId, []) then
  begin
    DonorSearchCombo.Text := '';
    MainDataSet.Edit;
    EditDonation(RecordId);
    //Must be valid so we can show the save button
    AddButton.Caption := 'Update';
    FPostCodeValid := true;
    FDonationDateValid := true;
    FBankingDateValid := true;
    AddButton.Enabled := true;
    SetCountry;
    RefreshValidation;
  end;
end;

procedure TManualEntryListForm2.PrepareForm;
begin
  FIdField := 'Id';
  // Set BatchId to zero so no result set is returned. New BatchId will be
  // created on saving of the first donation
  FBatchId := 0;
  InitialiseFieldMessages;
  CountryList.Items.Add(TCountryUtils.UNKNOWN);
end;

procedure TManualEntryListForm2.MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
begin
  inherited;
  ClearData;
  RefreshTimer.Enabled := true;
  RefreshBatchData;
end;

procedure TManualEntryListForm2.RefreshTimerTimer(Sender: TObject);
begin
  RefreshTimer.Enabled := false;
  RefreshData;
end;

procedure TManualEntryListForm2.RefreshData; {$IFDEF PAS2JS}async;{$ENDIF}
var
  FilterStr: string;
  lQuery: string;
begin
  FilterStr := 'ImportBatchId eq ' + FBatchId.ToString;
  FGridPlugin.SetPreparedFilter(FilterStr);
end;

procedure TManualEntryListForm2.GetNewBatchId; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CreateNewBatch',
    ['Manual', '', MainData.AppUser.InternalId]));
  lResult := lRetval.ResultAsObject;
  FBatchId := JS.toInteger(lResult['value']);

  WaitForBatchIdTimer.Enabled := true;
end;

function TManualEntryListForm2.InitSortCol: Integer;
begin
  result := 0;
end;

function TManualEntryListForm2.InitSortDirection: TSortDirection;
begin
  result := sdDesc;
end;

procedure TManualEntryListForm2.MergeButtonClick(Sender: TObject);
begin
  MergeDataJob;
  FBatchId := 0;
  RefreshData;
  RefreshBatchData;
  MergeButton.Enabled := false;
end;

procedure TManualEntryListForm2.SaveDonationClick(Sender: TObject);
begin
  if TRequiredFieldsUtils.ValidateAndShowMessage(Self) then
  begin
    SaveNewDonation;
    MergeButton.Enabled := true;
  //  SaveDonationData;
  end;
end;

procedure TManualEntryListForm2.SaveNewDonation;
begin
  if FBatchId = 0 then
  begin
    GetNewBatchId;
  end
  else
  begin
    SaveDonationData;
    //SaveNewDonationWithBatchId;
  end;
end;

procedure TManualEntryListForm2.SaveNewDonationWithBatchId;
begin
  try
    MainDataset.FieldByName('ImportBatchId').AsInteger := FBatchId;
    MainDataset.FieldByName('SourceType').AsString := 'Manual';
    MainDataset.FieldByName('GiftAid').AsFloat := 0.00;
    MainDataset.FieldByName('ImportState').AsString := 'Valid';
    MainDataset.Post;
  finally
    MainDataset.ApplyUpdates;
  end;
end;

procedure TManualEntryListForm2.SetDateAddedValidation(bValid: boolean);
begin
  FDonationDateValid := bValid;
end;

procedure TManualEntryListForm2.UnLockControls(const AUnLock: Boolean);
begin
//
end;

procedure TManualEntryListForm2.WaitForBatchIdTimerTimer(Sender: TObject);
begin
  if FBatchId <> 0 then
  begin
    //    SaveNewDonationWithBatchId;
    SaveDonationData;
    WaitForBatchIdTimer.Enabled := false;
  end;
end;

procedure TManualEntryListForm2.RefreshBatchData; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  if FBatchId <> 0 then
  begin
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.GetManualBatchData', [FBatchId]));
    lResult := lRetval.ResultAsObject;

    FBatchTotal := JS.toNumber(lResult['BatchTotal']);

    FNoOfDonations := JS.toInteger(lResult['NoOfDonations']);
    FNoOfErrors := JS.toInteger(lResult['NoOfErrors']);
    FMergeEnabled := FNoOfErrors = 0;
    WaitForBatchDataTimer.Enabled := true;
  end;
  UpdateBatchAmountLabel;
end;

procedure TManualEntryListForm2.WaitForBatchDataTimerTimer(Sender: TObject);
begin
  MergeButton.Enabled := FMergeEnabled;
  DonationsData.Caption := Format('Donations Total: %0.2f No of Donations: %d', [FBatchTotal, FNoOfDonations]);
  WaitForBatchDataTimer.Enabled := false;
end;

procedure TManualEntryListForm2.MergeDataJob; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lJobParams: JS.TJSObject;
  lRetval: TXDataClientResponse;
  JobId: Integer;
begin
  if FBatchId <> 0 then
  begin
    lJobParams := JS.TJSObject.new;
    lJobParams.Properties['ImportId'] := FBatchId;

    lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_SCHEDULEJOB,
      ['TImportMergeJob', 'AnyAdminUser', JS.TJSJSON.stringify(lJobParams), 'Undecided', 'Production']));

    JobId := JS.toInteger(lRetval.ResultAsObject['value']);

    // EnableRefreshTimer;

    ShowAToast('Data Merge', Format('The job to merge your import data has been placed. The Job Number is %d', [JobId]),
      'clock.png');
  end;
end;

procedure TManualEntryListForm2.LoadData;
begin

end;

procedure TManualEntryListForm2.ClearButtonClick(Sender: TObject);
begin
  InitialiseFieldMessages;
  ClearData;
end;

procedure TManualEntryListForm2.NextRecordTimerTimer(Sender: TObject);
begin
  NextRecordTimer.Enabled := false;
  MainDataSet.Insert;
end;

procedure TManualEntryListForm2.WebFormCreate(Sender: TObject);
begin
  FEssentialsMappings := [
    TPair<string, string>.Create('ImportDonation', 'Donation'),
    TPair<string, string>.Create('ImportDonation.Title', 'Donor'),
    TPair<string, string>.Create('ImportDonation.Add2', 'Donor'),
    TPair<string, string>.Create('ImportDonation.Add3', 'Donor'),
    TPair<string, string>.Create('ImportDonation.City', 'Donor')
  ];
  inherited;
end;

procedure TManualEntryListForm2.WebFormShow(Sender: TObject);
begin
  BindDomHandlers;

  lcPaginator.Visible := true;
  CreateGridPlugin;

  // Register required-field mappings from label ids (entity.field.label).
  AutoRegisterNonDataAwareRequiredFieldControls;


  CheckForOpenManualBatches;
  SetLookups;
  DonationDefaults.Load;
  ClearData;
  LookupsDataset.Active := True;
end;

procedure TManualEntryListForm2.BindDomHandlers;
var
  Element: TJSHTMLElement;

  function DeclarationClick(Event: TJSMouseEvent): Boolean;
  begin
    if Assigned(Event) then
    begin
      Event.preventDefault;
      Event.stopPropagation;
    end;

    DonorDeclarationButtonClick(Self);
    Result := False;
  end;

begin
  Element := TJSHTMLElement(document.getElementById('DonorDeclarationButton'));
  if Assigned(Element) then
  begin
    Element.onclick := @DeclarationClick;
    Element.style.setProperty('cursor', 'pointer');
  end;
end;

procedure TManualEntryListForm2.AutoRegisterNonDataAwareRequiredFieldControls;
  procedure RegisterRequiredControl(ACtrl: TControl; const AEntityClassName, AFieldName: string);
  begin
    if ACtrl <> nil then
      EssentialsManager.RequiredFieldsManager.RegisterNonDataAwareControl(
        ACtrl, AEntityClassName, AFieldName);
  end;
begin
  RegisterRequiredControl(TitleEdit, 'TDonor', 'Title');
  RegisterRequiredControl(Add2Edit, 'TDonor', 'Add2');
  RegisterRequiredControl(Add3Edit, 'TDonor', 'Add3');
  RegisterRequiredControl(CityEdit, 'TDonor', 'City');

  RegisterRequiredControl(OtherDonationKindEdit, 'TDonation', 'OtherDonationKind');
  RegisterRequiredControl(BankingDateEdit, 'TDonation', 'BankingDate');
  RegisterRequiredControl(PaymentMethodNoteEdit, 'TDonation', 'PaymentMethodNote');
  RegisterRequiredControl(DonationClaimStatus, 'TDonation', 'ClaimStatus');
  RegisterRequiredControl(SponsoredEdit, 'TDonation', 'Sponsored');
  RegisterRequiredControl(CommentMemo, 'TDonation', 'Comment');
  RegisterRequiredControl(AnalysisCode1Combo, 'TDonation', 'AnalysisCode1');
  RegisterRequiredControl(AnalysisCode2Combo, 'TDonation', 'AnalysisCode2');
  RegisterRequiredControl(BankingReferenceCombo, 'TDonation', 'BankingReference');
  RegisterRequiredControl(BankingReference2Edit, 'TDonation', 'BankingReference2');
end;

function TManualEntryListForm2.CreateGridInFormCreate: Boolean;
begin
  cbPageSize.ItemIndex := 0;
  result := false;
end;

procedure TManualEntryListForm2.DateAddedEditDBChange(Sender: TObject);
begin
  ValidateDate;
end;

procedure TManualEntryListForm2.PaymentMethodComboChange(Sender: TObject);
begin
  if PaymentMethodCombo.Value = 'Other' then

    PaymentMethodNoteEdit.Enabled := True
  else
    PaymentMethodNoteEdit.Enabled := False;

  ValidateDonation;
end;


procedure TManualEntryListForm2.PaymentMethodComboExit(Sender: TObject);
begin
  if PaymentMethodNoteEdit.Enabled = False then
    PaymentMethodNoteEdit.Text := '';
end;

procedure TManualEntryListForm2.PostCodeEditChange(Sender: TObject);
var
  lPostCode: string;
begin
  FPostCodeValid := False;
  TDocUtils.setControlValidity('PostCodeEdit', vsNone);

  lPostCode := StringReplace(Trim(PostCodeEdit.Text), ' ', '', [rfReplaceAll]);
  if (lPostCode <> '') and (Length(lPostCode) >= 5) then
  begin
    ValidatePostCode;
    Exit;
  end;

  ValidateDonation;
end;

procedure TManualEntryListForm2.PostCodeEditExit(Sender: TObject);
begin
  ValidatePostCode;
end;

procedure TManualEntryListForm2.ValidatePostCode;
var
  lPostCode: string;
begin
  lPostCode := Trim(PostCodeEdit.Text).ToUpper;
  while Pos('  ', lPostCode) > 0 do
    lPostCode := StringReplace(lPostCode, '  ', ' ', []);

  if lPostCode = '' then
  begin
    FPostCodeValid := False;
    TDocUtils.setControlValidity('PostCodeEdit', vsNone);
  end
  else
  begin
    // Allow users to enter UK postcodes without a space (minimum 5 chars),
    // then normalise to canonical format.
    lPostCode := StringReplace(lPostCode, ' ', '', [rfReplaceAll]);
    if Length(lPostCode) >= 5 then
      lPostCode := TCRMUtils.FormatPostCode(lPostCode);

    PostCodeEdit.Text := lPostCode;
    if TCRMUtils.IsPostCode(lPostCode) <> pcFull then
    begin
      TDocUtils.setControlValidity('PostCodeEdit', vsInvalid);
      FPostCodeValid := false;
    end
    else
    begin
      TDocUtils.setControlValidity('PostCodeEdit', vsValid);
      FPostCodeValid := True;
    end;
  end;
  ValidateDonation;
end;

procedure TManualEntryListForm2.InitialiseFieldMessages;
begin
  TDocUtils.setControlValidity('AmountEdit', vsNone);
  TDocUtils.setControlValidity('PostCodeEdit', vsNone);
  TDocUtils.setControlValidity('DonationDateEdit', vsNone);
end;

procedure TManualEntryListForm2.MainDatasetAfterDelete(DataSet: TDataSet);
begin
  inherited;
  MainDataSet.ApplyUpdates;
end;

procedure TManualEntryListForm2.MainDatasetAmountGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := FormatFloat(SYS_MONEY_FORMAT, (Sender as TFloatField).AsFloat);
end;

procedure TManualEntryListForm2.EditExit(Sender: TObject);
begin
  //CheckValidation;
  SetDonorKind;
end;

procedure TManualEntryListForm2.SetCountryCode;
begin
end;

procedure TManualEntryListForm2.SetCountry;
var
  isUK: Boolean;
begin
  isUK := Pos('United Kingdom', CountryList.Text) > 0;
  if isUK  then
  begin
    FNonUkCountry := false;
    ValidatePostCode;
  end
  else
  begin
    //KSS PostCodeEdit.Text := '';
    FNonUkCountry := true;
  end;
  TDocUtils.ShowHideElement('PostCodeRequiredSVG', isUK);
end;

procedure TManualEntryListForm2.SetCountryFromCountryCode(ACountryCode: string);
var
  lCountry: string;
begin
  lCountry := TCountryUtils.GetCountryFromCountryCodeHelper(ACountryCode);
  CountryList.Text := lCountry;
end;

procedure TManualEntryListForm2.CheckForDuplicates; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  lFirstName: string;
  lLastName: string;
  lAmountStr: string;
  lAmount: double;
  lTransactionDate: TDate;
  lPostCode: string;
  lIsDuplicate: boolean;
begin
  try
    lFirstName := FirstNameEdit.Text;
    lLastName := LastNameEdit.Text;
    lPostCode := PostCodeEdit.Text;
    lAmountStr := AmountEdit.Text;
    lAmount := lAmountStr.ToDouble;
    lTransactionDate := DonationDateEdit.Date;

    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.ManualEntryDuplicates', [lFirstName, lLastName, lPostCode, lTransactionDate, lAmount, FBatchId]));

    FIsDuplicate := JS.toBoolean(lRetval.ResultAsObject['value']);
    EnableSaveButtonTimer.Enabled := true;
//    CheckEnableSaveButton;
  except

  end;
end;

procedure TManualEntryListForm2.EnableSaveButtonTimerTimer(Sender: TObject);
var
  lRes: TModalResult;
begin
  EnableSaveButtonTimer.Enabled := False;
end;

procedure TManualEntryListForm2.ValidateChange(Sender: TObject);
var
  lAmount: double;
begin
  //FAmountOk := False;
  if AmountEdit.Text <> '' then
  begin
    lAmount := strtofloat(AmountEdit.text);
    if lAmount > 0.00 then
    begin
      TDocUtils.setControlValidity('AmountEdit', vsValid);
      //FAmountOk := True;
    end
    else
    begin
      TDocUtils.setControlValidity('AmountEdit', vsInvalid);
      //FAmountOk := False;
    end;
  end
  else
    TDocUtils.setControlValidity('AmountEdit', vsInvalid);

  ValidateDonation;
end;

procedure TManualEntryListForm2.FirstNameEditDBChange(Sender: TObject);
begin
  //inherited;
  SearchData(FirstNameEdit.Text);
end;

procedure TManualEntryListForm2.ValidateDate;
var
  lValidDate: TDate;
  lYear: string;
  lMonth: string;
  lDay: string;
  lDateStr: string;
  lEarliestDate: TDateTime;
begin
  FDonationDateValid := False;
  lDateStr := DonationDateEdit.Text;

  if Length(lDateStr) > 10 then
    DonationDateEdit.Text := Copy(lDateStr, 1, 10);

  if Length(lDateStr) >= 10 then
  begin
    lDay := Copy(lDateStr,9,2);
  end;

  if Length(lDateStr) >= 7 then
  begin
    lMonth := Copy(lDateStr,6,2);
  end;

  if Length(lDateStr) >= 4 then
  begin
    lYear := Copy(lDateStr,1,4);
  end;

  if (lDay <> '') and (lMonth <> '') and (lYear <> '') and (lYear.ToInteger > 2000) then
  begin
    if IsValidDate(lYear.ToInteger, lMonth.ToInteger, lDay.ToInteger) then
    begin
      if DonationDateEdit.Date > Date then
      begin
        ErrorMessageTransactionDate.Caption := 'Date in the future';
        TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
        FDonationDateValid := false;
      end
      else
      begin
        lEarliestDate := TGAWebUtils.EarliestClaimableDate(Now);

        if lEarliestDate > DonationDateEdit.Date then
        begin
          ErrorMessageTransactionDate.Caption := 'Date can not be before ' + FormatDateTime('DD/MM/YYYY', lEarliestDate);
          TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
          FDonationDateValid := False;
        end
        else
        begin
          TDocUtils.setControlValidity('DonationDateEdit', vsValid);
          FDonationDateValid := true;
        end;
      end;
    end;
  end;

  if (Length(DonationDateEdit.Text) = 10) then
    ValidateDonation;
end;

procedure TManualEntryListForm2.CheckForOpenManualBatches; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CheckForOpenBatch',
    [MainData.AppUser.InternalId]));
  lResult := lRetval.ResultAsObject;
  FBatchId := JS.toInteger(lResult['value']);

  RefreshTimer.Enabled := true;
  //Need this to update FBatchTotal
  Await(RefreshBatchData);
end;

procedure TManualEntryListForm2.FullNameEditSelect(Sender: TObject;
  Args: TEditAutoCompleteSelectEventArgs);
var
  lIndex: integer;
begin
  lIndex := Args.ItemIndex;

  Caption := inttostr(lIndex);

  //PopulateFromAutoSearch(lIndex);
end;


procedure TManualEntryListForm2.DonorSearchComboChange(Sender: TObject);
begin
  SearchData(DonorSearchCombo.Text);
end;


procedure TManualEntryListForm2.DonorSearchComboClick(Sender: TObject);
var
  lDonorId: integer;
begin
  if AddButton.Caption = 'Update' then
    AddButton.Caption := 'Add';

  if TryGetSelectedDonorId(lDonorId) then
    SetDonor;
end;

procedure TManualEntryListForm2.SearchData(const AValue: string);
var
  FilterStr: string;
  lQuery: string;
  lDonorId: integer;
begin
  if DonorSearchCombo.Text = '' then
  begin
    DonorSearchCombo.Items.Clear;
    DonorSearchCombo.Text := '';
    ClearData;
  end
  else if (Length(AValue) = 3) AND (DonorSearchCombo.Items.Count = 0) then
  begin
    lQuery := format
    ('contains(upper(FirstName), ''%s'') or contains(upper(LastName), ''%s'') ' +
    'or contains(upper(OrganisationName), ''%s'')',[Uppercase(AValue),Uppercase(AValue),Uppercase(AValue)]);

    DonorsDataset.Close;
    DonorsDataset.QueryString := '$filter=' + lQuery;
    DonorsDataset.Load;
  end
  else
  begin
    DonorSearchCombo.DroppedDown := true;
  end;

  if TryGetSelectedDonorId(lDonorId) then
    SetDonor;
end;

procedure TManualEntryListForm2.DonationDateEditChange(Sender: TObject);
begin
  ValidateDate;
end;

procedure TManualEntryListForm2.DonationKindComboChange(Sender: TObject);
begin
  SetDonationClaimStatusBasedOnDonationKind;

  if DonationKindCombo.Value = TDonationUIUtils.OTHER then
    OtherDonationKindEdit.Enabled := True
  else
    OtherDonationKindEdit.Enabled := False;

  ValidateDonation;
end;

procedure TManualEntryListForm2.DonationKindComboExit(Sender: TObject);
begin
  if OtherDonationKindEdit.Enabled = False then
    OtherDonationKindEdit.Text := '';
end;

procedure TManualEntryListForm2.DonorsDatasetAfterOpen(DataSet: TDataSet);
begin
  LoadDonors;
end;

procedure TManualEntryListForm2.LoadDonors;
var
  lName: string;
  lText: string;
  lId: integer;
  lComboId: integer;
  lDonorClaimStatus: string;
  //lComboName: string;
begin
  DonorSearchCombo.Items.Clear;
  lText := DonorSearchCombo.Text;
  while not DonorsDataset.eof do
  begin
    lDonorClaimStatus := DonorsDataset.FieldByName('ClaimStatus').AsString;
    if (lDonorClaimStatus <> 'Deceased') and (lDonorClaimStatus <> 'Inactive') then
    begin
      if (DonorsDataset.FieldByName('DonorKind').AsString = 'Individual') or (DonorsDataset.FieldByName('DonorKind').AsString = '') then
      begin
        lName := DonorsDataset.FieldByName('FirstName').AsString + ' ' +
                 DonorsDataset.FieldByName('LastName').AsString + ', ' +
                 DonorsDataset.FieldByName('Add1').AsString + ', ' +
                 DonorsDataset.FieldByName('PostCode').AsString + ' - ' + '[' +
                 DonorsDataset.FieldByName('Id').AsString + ']';
      end
      else
      begin
        //Could be an Organisation so we'll check
        //if DonorsDataset.FieldByName('OrganisationName').AsString = '' then
        if (DonorsDataset.FieldByName('DonorKind').AsString = 'Company') or
           (DonorsDataset.FieldByName('DonorKind').AsString = 'Charity') then
        begin
          lName := DonorsDataset.FieldByName('OrganisationName').AsString + ', ' +
                   DonorsDataset.FieldByName('Add1').AsString + ', ' +
                   DonorsDataset.FieldByName('PostCode').AsString + ' - ' + '[' +
                   DonorsDataset.FieldByName('Id').AsString + ']';
        end;
      end;

      lComboId := DonorSearchCombo.Items.Add(lName);
      lId := DonorsDataset.FieldByName('Id').AsInteger;
    end;
    DonorsDataset.Next;
  end;

  DonorSearchCombo.Text := lText;
end;

function TManualEntryListForm2.TryGetSelectedDonorId(out ADonorId: integer): Boolean;
var
  lIdStr: string;
  lData: string;
  lPosStart, lPosEnd: integer;
begin
  Result := False;
  ADonorId := 0;

  if DonorSearchCombo.ItemIndex <> -1 then
    lData := DonorSearchCombo.Items[DonorSearchCombo.ItemIndex]
  else
    lData := DonorSearchCombo.Text;

  if lData = '' then
    Exit;

  lPosStart := Pos('[', lData) + 1;
  lPosEnd := Pos(']', lData);
  if (lPosStart <= 1) or (lPosEnd <= lPosStart) then
    Exit;

  lIdStr := Copy(lData, lPosStart, lPosEnd-lPosStart);
  Result := TryStrToInt(lIdStr, ADonorId);
end;

procedure TManualEntryListForm2.SetDonor;
var
  lId: integer;
begin
  if not TryGetSelectedDonorId(lId) then
    Exit;

  if DonorsDataset.Locate('Id', lId, []) then
  begin
    LoadDonorData;
    LoadDefaults(lId);
    GetDeclaration(lId);
    ValidateDonation;
  end;
end;

procedure TManualEntryListForm2.LoadDonorData;
var
  lCountryCode: string;
  lDonorKind: string;
begin
  FDonorId := DonorsDataset.FieldByName('Id').AsInteger;
  lDonorKind := DonorsDataset.FieldByName('DonorKind').AsString;
  if lDonorKind = '' then
    lDonorKind := 'Individual';

  TitleEdit.Text := '';
  FirstNameEdit.Text := '';
  LastNameEdit.Text := '';
  OrganisationNameEdit.Text := '';

  if lDonorKind = 'Individual' then
  begin
    TitleEdit.Text := DonorsDataset.FieldByName('Title').AsString;
    FirstNameEdit.Text := DonorsDataset.FieldByName('FirstName').AsString;
    LastNameEdit.Text := DonorsDataset.FieldByName('LastName').AsString;
  end
  else
  begin
    OrganisationNameEdit.Text := DonorsDataset.FieldByName('OrganisationName').AsString;
  end;

  DonorKindCombo.Value := lDonorKind;
  DonorClaimStatusCombo.Value := DonorsDataset.FieldByName('ClaimStatus').AsString;

//KSS  if Uppercase(DonorClaimStatusCombo.Value) <> 'OK' then
//KSS    TDonationUIUtils.AddDonationClaimStatusNotEligibleForGiftAidLookupsToCombo(DonationClaimStatus.LookupValues);

  Add1Edit.Text := DonorsDataset.FieldByName('Add1').AsString;
  Add2Edit.Text := DonorsDataset.FieldByName('Add2').AsString;
  Add3Edit.Text := DonorsDataset.FieldByName('Add3').AsString;
  CityEdit.Text := DonorsDataset.FieldByName('City').AsString;
  PostCodeEdit.Text := DonorsDataset.FieldByName('PostCode').AsString;
  SponsoredEdit.Checked := DonorsDataset.FieldByName('Sponsored').AsString = 'Y';
  lCountryCode := DonorsDataset.FieldByName('CountryCode').AsString;
  if lCountryCode = '' then
    lCountryCode := 'GB';
  SetCountryFromCountryCode(lCountryCode);
  SetCountry;
  FDateOfDeath := DonorsDataset.FieldByName('DateOfDeath').AsDateTime;

  ValidatePostCode;
end;

procedure TManualEntryListForm2.EditDonation(ARecordId: integer);
var
  lCountryCode: string;
begin
  FDonorId := 0;

  if not MainDataset.FieldByName('MatchedPerson').IsNull then
    FDonorId := MainDataset.FieldByName('MatchedPerson').AsInteger;

  TitleEdit.Text := MainDataset.FieldByName('Title').AsString;
  FirstNameEdit.Text := MainDataset.FieldByName('FirstName').AsString;
  LastNameEdit.Text := MainDataset.FieldByName('LastName').AsString;
  OrganisationNameEdit.Text := MainDataset.FieldByName('OrganisationName').AsString;
  DonorKindCombo.Value := MainDataset.FieldByName('DonorKind').AsString;

  Add1Edit.Text := MainDataset.FieldByName('Add1').AsString;
  Add2Edit.Text := MainDataset.FieldByName('Add2').AsString;
  Add3Edit.Text := MainDataset.FieldByName('Add3').AsString;
  CityEdit.Text := MainDataset.FieldByName('City').AsString;
  PostCodeEdit.Text := MainDataset.FieldByName('PostCode').AsString;
  AmountEdit.Text := MainDataset.FieldByName('Amount').AsString;

  DonationDateEdit.Date := MainDataset.FieldByName('DonationDate').AsDateTime;
  SponsoredEdit.Checked := MainDataset.FieldByName('Sponsored').AsBoolean;// = 'Y';

  lCountryCode := MainDataset.FieldByName('CountryCode').AsString;
  SetCountryFromCountryCode(lCountryCode);

  DonationKindCombo.Value := MainDataset.FieldByName('DonationKind').AsString;
  OtherDonationKindEdit.Text := MainDataset.FieldByName('OtherDonationKind').AsString;
  PaymentMethodCombo.Value := MainDataset.FieldByName('PaymentMethod').AsString;
  PaymentMethodNoteEdit.Text := MainDataset.FieldByName('PaymentMethodNote').AsString;
  BankingDateEdit.Date := MainDataset.FieldByName('BankingDate').AsDateTime;
  DonationClaimStatus.Value := MainDataset.FieldByName('DonationClaimStatus').AsString;
  CommentMemo.Text := MainDataset.FieldByName('Comment').AsString;
  //KSS AnalysisCode1DefaultCombo.Value := MainDataset.FieldByName('AnalysisCode1').AsString;
  //KSS AnalysisCode2DefaultCombo.Value := MainDataset.FieldByName('AnalysisCode2').AsString;
  DonorClaimStatusCombo.Value := MainDataset.FieldByName('ClaimStatus').AsString;
//  BankingReferenceEdit.Text := MainDataset.FieldByName('BankingReference').AsString;
  BankingReference2Edit.Text := MainDataset.FieldByName('BankingReference2').AsString;

  if not MainDataset.FieldByName('DeclarationClaimCoverage').IsNull then
  begin
  if MainDataset.FieldByName('DeclarationClaimCoverage').AsString = 'Single' then
  begin
    AddNoDeclarationOptions;
    DeclarationCombo.ItemIndex := 1;
  end
  else if FDonorId = 0 then
  begin
    FNewDonorDeclarationDateSigned := MainDataset.FieldByName('DeclarationDateSigned').AsDateTime;
    FNewDonorDeclarationStatus     := MainDataset.FieldByName('DeclarationStatus').AsString;
    FNewDonorDeclarationCoverage   := MainDataset.FieldByName('DeclarationClaimCoverage').AsString;
    FNewDonorDeclarationMethod     := MainDataset.FieldByName('DeclarationMethod').AsString;
    ApplyNewDonorDeclaration;
  end
  else
  begin
    GetDeclaration(FDonorId);
  end;
  end;

  ClearButton.Enabled := True;
  AnalysisCode1Combo.ItemIndex := AnalysisCode1Combo.Items.IndexOf(MainDataset.FieldByName('AnalysisCode1').AsString);
  AnalysisCode2Combo.ItemIndex := AnalysisCode2Combo.Items.IndexOf(MainDataset.FieldByName('AnalysisCode2').AsString);
  BankingReferenceCombo.ItemIndex := BankingReferenceCombo.Items.IndexOf(MainDataset.FieldByName('BankingReference').AsString);

  SetCountryFromCountryCode(lCountryCode);
end;

procedure TManualEntryListForm2.SaveDonationData;
var
  lCountryCode: string;
begin
  WaitForBatchIdTimer.Enabled := False;

  if MainDataset.State = dsEdit then
  begin
    MainDataset.Edit;
  end
  else
  begin
    MainDataset.Active := True;
    MainDataset.Insert;

    if FDonorId > 0 then
    begin
      if FDonorId > 0 then
        MainDataset.FieldByName('MatchedPerson').AsInteger := FDonorId;
    end;
  end;

  MainDataset.FieldByName('DonorKind').AsString := DonorKindCombo.Value;

  //if MainDataset.FieldByName('DonorKind').AsString = 'Individual' then
  //begin
  MainDataset.FieldByName('Title').AsString       := TitleEdit.Text;
  MainDataset.FieldByName('FirstName').AsString   := FirstNameEdit.Text;
  MainDataset.FieldByName('LastName').AsString    := LastNameEdit.Text;
  //end
  //else
  //begin
  MainDataset.FieldByName('OrganisationName').AsString := OrganisationNameEdit.Text;
  //end;

  MainDataset.FieldByName('Add1').AsString        := Add1Edit.Text;
  MainDataset.FieldByName('Add2').AsString        := Add2Edit.Text;
  MainDataset.FieldByName('Add3').AsString        := Add3Edit.Text;
  MainDataset.FieldByName('City').AsString        := CityEdit.Text;

  if not FNonUkCountry then
    MainDataset.FieldByName('PostCode').AsString    := PostCodeEdit.Text;

  MainDataset.FieldByName('Amount').AsString      := AmountEdit.Text;
  MainDataset.FieldByName('DonationDate').AsDateTime := DonationDateEdit.Date;
  MainDataset.FieldByName('Sponsored').AsBoolean  := SponsoredEdit.Checked;

  lCountryCode := TCountryUtils.GetCountryCodeFromCountryHelper(CountryList.Text);
  MainDataset.FieldByName('CountryCode').AsString := lCountryCode;

  MainDataset.FieldByName('ImportBatchId').AsInteger := FBatchId;
  MainDataset.FieldByName('SourceType').AsString := 'Manual';
  MainDataset.FieldByName('GiftAid').AsFloat := 0.00;
  MainDataset.FieldByName('ImportState').AsString := 'Valid';
  MainDataset.FieldByName('DonationKind').AsString := DonationKindCombo.Value;
  MainDataset.FieldByName('OtherDonationKind').AsString := OtherDonationKindEdit.Text;
  MainDataset.FieldByName('PaymentMethod').AsString := PaymentMethodCombo.Value;
  MainDataset.FieldByName('PaymentMethodNote').AsString := PaymentMethodNoteEdit.Text;
  MainDataset.FieldByName('BankingDate').AsDateTime := BankingDateEdit.Date;
  MainDataset.FieldByName('DonationClaimStatus').AsString := DonationClaimStatus.Value;
  MainDataset.FieldByName('ClaimStatus').AsString := DonorClaimStatusCombo.Value;
  //KSS MainDataset.FieldByName('AnalysisCode1').AsString := AnalysisCode1DefaultCombo.Value;
  //KSS MainDataset.FieldByName('AnalysisCode2').AsString := AnalysisCode2DefaultCombo.Value;
  MainDataset.FieldByName('Comment').AsString := CommentMemo.Text;

  if AnalysisCode1Combo.ItemIndex <> -1 then
    MainDataset.FieldByName('AnalysisCode1').AsString := AnalysisCode1Combo.Items[AnalysisCode1Combo.ItemIndex];

  if AnalysisCode2Combo.ItemIndex <> -1 then
    MainDataset.FieldByName('AnalysisCode2').AsString := AnalysisCode2Combo.Items[AnalysisCode2Combo.ItemIndex];

  if BankingReferenceCombo.ItemIndex <> -1 then
    MainDataset.FieldByName('BankingReference').AsString := BankingReferenceCombo.Items[BankingReferenceCombo.ItemIndex];

//  MainDataset.FieldByName('BankingReference').AsString := BankingReferenceEdit.Text;
  MainDataset.FieldByName('BankingReference2').AsString := BankingReference2Edit.Text;;

  if (DeclarationCombo.Text <> 'None') then
  begin
    if DeclarationCombo.Text = 'Single' then
    begin
      MainDataset.FieldByName('DeclarationDateSigned').AsDateTime := DonationDateEdit.Date;
      MainDataset.FieldByName('DeclarationStatus').AsString := 'Active';
      MainDataset.FieldByName('DeclarationClaimCoverage').AsString := 'Single';
      MainDataset.FieldByName('DeclarationMethod').AsString := 'Unknown';
    end
    else
    begin
      if (FDonorId = 0) then
      begin
        MainDataset.FieldByName('DeclarationDateSigned').AsDateTime := FNewDonorDeclarationDateSigned;
        MainDataset.FieldByName('DeclarationStatus').AsString := FNewDonorDeclarationStatus;
        MainDataset.FieldByName('DeclarationClaimCoverage').AsString := FNewDonorDeclarationCoverage;
        MainDataset.FieldByName('DeclarationMethod').AsString := FNewDonorDeclarationMethod;
      end;
    end;

    if FDeclarationId <> 0 then
      MainDataset.FieldByName('DeclarationId').AsInteger := FDeclarationId;
  end;

  EssentialsManager.LookUpManager.ClearEmptyComboSelections(Self);
  MainDataset.Post;
  ClearData;
end;

procedure TManualEntryListForm2.RefreshValidation;
begin
  // Programmatic value assignment does not trigger DOM input/change events,
  // so re-run validators to refresh visual validity classes and button state.
  ValidateChange(AmountEdit);
  ValidatePostCode;
  ValidateDate;
  ValidateDonation;
  TRequiredFieldsUtils.UpdateRequiredFieldsValidity(Self);
end;

procedure TManualEntryListForm2.ClearData;
begin
  FPostCodeValid := false;
  FDonationDateValid := false;
  FBankingDateValid := false;
  FNonUkCountry := false;

  AddButton.Enabled := False;
  AddButton.Caption := 'Add';
  ClearButton.Enabled := False;
  FDonorId := 0;
  TitleEdit.Text := '';
  FirstNameEdit.Text := '';
  LastNameEdit.Text := '';
  OrganisationNameEdit.Text := '';
  Add1Edit.Text := '';
  Add2Edit.Text := '';
  Add3Edit.Text := '';
  CityEdit.Text := '';
  PostCodeEdit.Text := '';
  AmountEdit.Text := '';
  SponsoredEdit.Checked := False;
  DonorSearchCombo.ItemIndex := -1;
  DonorSearchCombo.Text := '';
  DonorSearchCombo.Items.Clear;

  DonorKindCombo.ItemIndex := -1;
  DonationKindCombo.ItemIndex := -1;
  PaymentMethodCombo.ItemIndex := -1;
  DonationClaimStatus.ItemIndex := 0;
  DonorClaimStatusCombo.ItemIndex := MainData.OrganisationConfiguration.DonorClaimStatusItemIndex;
  AnalysisCode1Combo.ItemIndex := -1;
  AnalysisCode2Combo.ItemIndex := -1;

  OtherDonationKindEdit.Text := '';
  OtherDonationKindEdit.Enabled := False;

  PaymentMethodNoteEdit.Text := '';
  PaymentMethodNoteEdit.Enabled := False;

  DonationDateEdit.Date := 0;
  BankingDateEdit.Date := 0;
  DonationDateEdit.Text := 'dd/mm/yyyy';
  BankingDateEdit.Text := 'dd/mm/yyyy';

  BankingReferenceCombo.ItemIndex := -1;
  BankingReference2Edit.Text := '';

  DeclarationCombo.Items.Clear;
  DeclarationCombo.Text := '';
  AddNoDeclarationOptions;

  cbPageSize.ItemIndex := 0;

  SetCountryFromCountryCode('GB');
  CommentMemo.Text := '';
  DonorSearchCombo.SetFocus;
  FDeclarationId := 0;
  FDateOfDeath := 0;

  MainDataset.Cancel;

  // Re-evaluate required field validity after programmatic reset of control values.
  TRequiredFieldsUtils.UpdateRequiredFieldsValidity(Self);
end;

procedure TManualEntryListForm2.CountryListChange(Sender: TObject);
begin
  SetCountry;
  ValidateDonation;
end;

procedure TManualEntryListForm2.BankingReferenceComboChange(Sender: TObject);
begin
  ValidateDonation;
end;

procedure TManualEntryListForm2.BlankEditBox(AEditBox: TEdit);
begin
  AEditBox.Text := '';
end;

procedure TManualEntryListForm2.SetLookups;
begin
  TDonationUIUtils.AddDonorKindLookupsToCombo(DonorKindCombo.LookupValues);
  TDonationUIUtils.AddDonationClaimStatusLookupsToCombo(DonationClaimStatus.LookupValues);
  TDonationUIUtils.AddPaymentMethodLookupsToCombo(PaymentMethodCombo.LookupValues);
  TDonationUIUtils.AddDonationKindLookupsToCombo(DonationKindCombo.LookupValues);
  TDonationUIUtils.AddDonorClaimStatusLookupsCombo(DonorClaimStatusCombo.LookupValues);
end;

procedure TManualEntryListForm2.LoadDefaults(ADonorId: integer);
var
  lDayOfMonth: integer;
  lDonationDate: TDate;
begin
  AmountEdit.Text := '';
  PaymentMethodCombo.Value := '';
  DonationKindCombo.Value := '';

  if DonationDefaults.Locate('DonorId', ADonorId, []) then
  begin
    AmountEdit.Text := DonationDefaults.FieldByName('Amount').AsString;
    PaymentMethodCombo.Value := DonationDefaults.FieldByName('PaymentMethod').AsString;
    DonationKindCombo.Value := DonationDefaults.FieldByName('DonationKind').AsString;
    AnalysisCode1Combo.ItemIndex := AnalysisCode1Combo.Items.IndexOf(DonationDefaults.FieldByName('AnalysisCode1').AsString);
    AnalysisCode2Combo.ItemIndex := AnalysisCode2Combo.Items.IndexOf(DonationDefaults.FieldByName('AnalysisCode2').AsString);
    BankingReferenceCombo.ItemIndex := BankingReferenceCombo.Items.IndexOf(DonationDefaults.FieldByName('BankingReference').AsString);

    if DonationKindCombo.Value = 'Other' then
    begin
     OtherDonationKindEdit.Enabled := true;
     OtherDonationKindEdit.Text := DonationDefaults.FieldByName('OtherDonationKind').AsString;
    end;

    SetDonationClaimStatusBasedOnDonationKind;

    lDayOfMonth := DonationDefaults.FieldByName('UsualDayOfMonth').AsInteger;

    if lDayOfMonth > 0 then
      SortDonationDate(lDayOfMonth, lDonationDate);

    ValidateDate;
    SetDonorKind;
  end;
end;

procedure TManualEntryListForm2.SortDonationDate(ADayOfMonth: integer; var ADonationDate: TDate);
var
  lDonationDate: TDate;
  lMonth: integer;
  lYear: integer;
begin
  lMonth := MonthOf(Now);
  lYear := YearOf(Now);
  lDonationDate := EncodeDateTime(lYear, lMonth, ADayOfMonth, 0, 0, 0, 0);

  if lDonationDate > Date then
  begin
    if lMonth = 1 then
      lDonationDate := EncodeDateTime(lYear-1, 12, ADayOfMonth, 0, 0, 0, 0)
    else
      lDonationDate := EncodeDateTime(lYear, lMonth-1, ADayOfMonth, 0, 0, 0, 0);
  end;

  DonationDateEdit.Date := lDonationDate;
end;

procedure TManualEntryListForm2.ValidateDonation;
var
  lAddressCheckNotRequired: boolean;
  lNewClaimStatus: string;
  lSetToUnclaimed: boolean;
begin
  if (Add1Edit.Text = '') and (PostCodeEdit.Text = '') then
  begin
    TDocUtils.ShowHideElement('PostCodeRequiredSVG', False);
    TDocUtils.ShowHideElement('Add1RequiredSVG', False);
    lAddressCheckNotRequired := true;
  end
  else
  begin
    TDocUtils.ShowHideElement('PostCodeRequiredSVG', True);
    TDocUtils.ShowHideElement('Add1RequiredSVG', True);
    lAddressCheckNotRequired := false;
  end;

  if (DonorKindCombo.Value = 'Individual') or (DonorKindCombo.Value = '')  then
  begin
    TDocUtils.ShowHideElement('FirstNameRequiredSVG', True);
    TDocUtils.ShowHideElement('LastNameRequiredSVG', True);
    TDocUtils.ShowHideElement('OrganisationNameRequiredSVG', False);
  end
  else
  begin
    TDocUtils.ShowHideElement('FirstNameRequiredSVG', False);
    TDocUtils.ShowHideElement('LastNameRequiredSVG', False);
    TDocUtils.ShowHideElement('OrganisationNameRequiredSVG', True);
  end;

  //if ((FPostCodeValid or FNonUkCountry) or lAddressCheckNotRequired) and FDonationDateValid and
  //  ((Add1Edit.Text <> '') or lAddressCheckNotRequired) and (AmountEdit.Text <> '') and

  if  (((FirstNameEdit.Text <> '') and (LastNameEdit.Text <> '')) or
    (OrganisationNameEdit.Text <> '')) and
    (CountryList.ItemIndex <> -1) and (DonorKindCombo.ItemIndex <> -1) and
    (PaymentMethodCombo.ItemIndex <> -1) and (DonationKindCombo.ItemIndex <> -1) and
    (DonationClaimStatus.ItemIndex <> -1) and (DonorClaimStatusCombo.ItemIndex <> -1) then
  begin
    AddButton.Enabled := true;
  end
  else
  begin
    AddButton.Enabled := false;
  end;
  ClearButton.Enabled := True;

  // Unclaimed test
  if ((DonationClaimStatus.Value <> 'NGACustomerRequest') and (DonationClaimStatus.Value <> 'Unknown')) then
  begin
    if TGARulesUtils.IsGiftAidAble(DonorKindCombo.Value, Add1Edit.Text, PostCodeEdit.Text, DonorClaimStatusCombo.Value) then
    begin
      if (FDateOfDeath = 0) or (DonationDateEdit.Date < FDateOfDeath) then
      begin
        // Is GiftAidable now check the Declaration
        if FDonorId <> 0 then
          //DonationClaimStatusRule(AddButton.Enabled)
          CheckDeclaration(AddButton.Enabled)
        else
          CheckDeclarationFornewDonor(AddButton.Enabled);
      end
      else
      begin
        DonationClaimStatus.Value := 'NonGiftAidable';
      end;
    end
    else
    begin
      DonationClaimStatus.Value := 'NonGiftAidable';
    end;
  end;
end;

procedure TManualEntryListForm2.SetDonorKind;
begin
  if (FirstNameEdit.Text <> '') or (LastNameEdit.Text <> '') or (TitleEdit.Text <> '') then
  begin
    OrganisationNameEdit.Text := '';
    DonorKindCombo.Value := 'Individual';
  end;

  if (OrganisationNameEdit.Text <> '') and (DonorKindCombo.Value = 'Individual') then
    DonorKindCombo.ItemIndex := -1;
end;

procedure TManualEntryListForm2.GetDeclaration(ADonorId: integer); {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  lDeclarationData: TComboBoxPairs;
  lDec: JS.TJSObject;
  lDate: TDate;
  lInt: integer;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetDeclarationWithId',
      [ADonorId]));
  lResult := lRetval.ResultAsObject;

  lDeclarationData := TComboBoxPairs.Create;
  lDeclarationData.Assign(lResult);

  DeclarationCombo.Items.Clear;
  if lDeclarationData.Display <> 'None' then
  begin
    DeclarationCombo.Items.Add(lDeclarationData.Display);
    DeclarationCombo.ItemIndex := 0;
    DeclarationCombo.Items.Add('None');
    FDeclarationId := strtoint(lDeclarationData.Value);
  end
  else
  begin
    AddNoDeclarationOptions;
  end;
end;

procedure TManualEntryListForm2.UpdateBatchAmountLabel;
const
  RUNNING_TOTAL_SCHEMA = 'Total Batch Amount: £';
begin
  if (FBatchID = 0) or (FNoOfDonations = 0) then
    lbBatchTotal.Caption := ''
  else
    lbBatchTotal.Caption := RUNNING_TOTAL_SCHEMA + FormatFloat('#,##0.00', FBatchTotal);
end;

procedure TManualEntryListForm2.DonorClaimStatusComboChange(Sender: TObject);
begin
//KSS  SetDonationClaimStatusLookUpsForDonorClaimStatus(DonorClaimStatusCombo.Value);
  ValidateDonation;
end;

procedure TManualEntryListForm2.DonorDeclarationButtonClick(Sender: TObject);
begin
  if FDonorId = 0 then
  begin
    if FNewDonorDeclarationOpening then
      Exit;
    FNewDonorDeclarationOpening := True;
    AddDeclarationForNewDonor
  end
  else
    ShowDeclarations;
end;

procedure TManualEntryListForm2.ShowDeclarations; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lId: integer;
  AForm: TDonorDeclarationsForm;
begin
//  lId := Dataset.FieldByName('Id').AsInteger;
  AForm := TDonorDeclarationsForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';

    await(TForm, AForm.Load());
    //AForm.LoadData;
    AForm.DonorId := FDonorId;
    AForm.FromManualEntry := True;
    AForm.DonationDate := DonationDateEdit.Date;
    AForm.DonationAmount := AmountEdit.Text;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    FDeclarationId := AForm.DeclarationId;
    AForm.Free;
    AForm := nil;
    GetDeclaration(FDonorId);
  end;
end;

procedure TManualEntryListForm2.AddDeclarationForNewDonor; {$IFDEF PAS2JS}async;{$ENDIF}
var
  //lId: integer;
  AForm: TDonorDeclarationNewDonorForm;
begin
//  lId := Dataset.FieldByName('Id').AsInteger;
  AForm := TDonorDeclarationNewDonorForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';

    await(TForm, AForm.Load());

    AForm.DateSigned := FNewDonorDeclarationDateSigned;
    AForm.Status := FNewDonorDeclarationStatus;
    AForm.Coverage := FNewDonorDeclarationCoverage;
    AForm.Method := FNewDonorDeclarationMethod;

    await(TModalResult, AForm.Execute);
  finally
    FNewDonorDeclarationDateSigned := AForm.DateSigned;
    FNewDonorDeclarationStatus := AForm.Status;
    FNewDonorDeclarationCoverage := AForm.Coverage;
    FNewDonorDeclarationMethod := AForm.Method;
    FNewDonorDeclarationOpening := False;

    AForm.Free;
    AForm := nil;

    ApplyNewDonorDeclaration;
  end;
end;

procedure TManualEntryListForm2.ApplyNewDonorDeclaration;
var
  lDeclaration: string;
begin
  lDeclaration := FNewDonorDeclarationCoverage + ':' + ' DateSigned: ' +
                  FormatDateTime('dd/mm/yyyy', FNewDonorDeclarationDateSigned);

  DeclarationCombo.Clear;
  DeclarationCombo.Items.Add(lDeclaration);
  DeclarationCombo.ItemIndex := 0;
  ValidateDonation;
end;

procedure TManualEntryListForm2.AddNoDeclarationOptions;
begin
  DeclarationCombo.Clear;
  DeclarationCombo.Items.Add('None');
  DeclarationCombo.ItemIndex := 0;
end;

procedure TManualEntryListForm2.SetDonationClaimStatusBasedOnDonationKind;
begin
  if DonationKindCombo.Value = TDonationUIUtils.FOREIGN_DONATION then
  begin
    DonationClaimStatus.Value := TDonationUIUtils.NONGIFTAIDABLE;
    DonationClaimStatus.Enabled := False;
  end
  else
    DonationClaimStatus.Enabled := True;
end;

procedure TManualEntryListForm2.SetDonationClaimStatusLookUpsForDonorClaimStatus(ADonorClaimStatus: string);
begin
  if Uppercase(DonorClaimStatusCombo.Value) <> 'OK' then
    TDonationUIUtils.AddDonationClaimStatusNotEligibleForGiftAidLookupsToCombo(DonationClaimStatus.LookupValues)
  else
    TDonationUIUtils.AddDonationClaimStatusLookupsToCombo(DonationClaimStatus.LookupValues);
end;

(*
procedure TManualEntryListForm2.DonationClaimStatusRule(AValidation: boolean);
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  lDeclarationData: string;
  lDate: TDate;
  lInt: integer;
  lDeclarationOk: boolean;
  lTransactionDate: TDate;

begin
  lTransactionDate := DonationDateEdit.Date;

  if lTransactionDate <> 0 then
  begin
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.CheckDeclaration',
        [FDonorId, lTransactionDate]));

    lResult := lRetval.ResultAsObject;
    lDeclarationOk := JS.ToBoolean(lResult['value']);

    if (lDeclarationOk and AValidation) then
      DonationClaimStatus.Value := 'Unclaimed'
    else
      DonationClaimStatus.Value := 'NonGiftAidable';
  end;
end;*)

procedure TManualEntryListForm2.CheckDeclarationFornewDonor(AValidation: boolean);
var
  lTransactionDate: TDate;
begin
  if FNewDonorDeclarationStatus = 'Active' then
  begin
    lTransactionDate := DonationDateEdit.Date;

    //if FNewDonorDeclarationCoverage = 'Single' then
    //begin
    //  if (FNewDonorDeclarationDateSigned = lTransactionDate) and AValidation then
    //    DonationClaimStatus.Value := 'Unclaimed'
    //  else
    //    DonationClaimStatus.Value := 'NonGiftAidable';
    //end
    //else
    begin
      //Single, Future and All
      if (FNewDonorDeclarationDateSigned <= lTransactionDate) and AValidation then
        DonationClaimStatus.Value := 'Unclaimed'
      else
        DonationClaimStatus.Value := 'NonGiftAidable';
    end;
  end
  else
    DonationClaimStatus.Value := 'NonGiftAidable';
end;

procedure TManualEntryListForm2.CheckDeclaration(AValidation: boolean);
begin
  if DeclarationCombo.Text <> 'None' then
    DonationClaimStatus.Value := 'Unclaimed'
  else
    DonationClaimStatus.Value := 'NonGiftAidable';
end;

procedure TManualEntryListForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  DonationsData := TLabel.Create(Self);
  ErrorMessageTransactionDate := TLabel.Create('ErrorMessageTransactionDate');
  lbBatchTotal := TLabel.Create('RunningTotal');
  MergeButton := TButton.Create('MergeButton');
  ClearButton := TButton.Create('ClearSelectButton');
  MessageDialog := TMessageDlg.Create(Self);
  DuplicateDialog := TMessageDlg.Create(Self);
  CountryList := TCountryComboBox.Create('CountryList');
  DeleteDonation := TMessageDlg.Create('deleteDonation');
  DeleteDonor := TMessageDlg.Create(Self);
  DonorSearchCombo := TComboBox.Create('DonorSearchCombo');
  TitleEdit := TEdit.Create('TitleEdit');
  FirstNameEdit := TEdit.Create('FirstNameEdit');
  LastNameEdit := TEdit.Create('LastNameEdit');
  Add1Edit := TEdit.Create('Add1Edit');
  Add2Edit := TEdit.Create('Add2Edit');
  Add3Edit := TEdit.Create('Add3Edit');
  CityEdit := TEdit.Create('CityEdit');
  PostCodeEdit := TEdit.Create('PostCodeEdit');
  AmountEdit := TEdit.Create('AmountEdit');
  DonationDateEdit := TDateTimePicker.Create('DonationDateEdit');
  SponsoredEdit := TCheckBox.Create('SponsoredEdit');
  DonationKindCombo := TLookupComboBox.Create('DonationKindCombo');
  OtherDonationKindEdit := TEdit.Create('OtherDonationKindEdit');
  DonorKindCombo := TLookupComboBox.Create('DonorKindCombo');
  PaymentMethodNoteEdit := TEdit.Create('PaymentMethodNoteEdit');
  DonorClaimStatusCombo := TLookupComboBox.Create('DonorClaimStatusCombo');
  OrganisationNameEdit := TEdit.Create('OrganisationNameEdit');
  PaymentMethodCombo := TLookupComboBox.Create('PaymentMethodCombo');
  DeclarationCombo := TComboBox.Create('DeclarationCombo');
  DonationClaimStatus := TLookupComboBox.Create('DonationClaimStatus');
  BankingDateEdit := TDateTimePicker.Create('BankingDate');
  CommentMemo := TMemo.Create('CommentMemo');
  AnalysisCode1Combo := TDBComboBox.Create('AnalysisCode1Combo');
  AnalysisCode2Combo := TDBComboBox.Create('AnalysisCode2Combo');
  DonorDeclarationButton := TButton.Create('DonorDeclarationButton');
  BankingReference2Edit := TEdit.Create('BankingReference2Edit');
  BankingReferenceCombo := TDBComboBox.Create('BankingReferenceCombo');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetTitle := TStringField.Create(Self);
  MainDatasetFirstName := TStringField.Create(Self);
  MainDatasetMiddleName := TStringField.Create(Self);
  MainDatasetLastName := TStringField.Create(Self);
  MainDatasetSuffix := TStringField.Create(Self);
  MainDatasetAdd1 := TStringField.Create(Self);
  MainDatasetAdd2 := TStringField.Create(Self);
  MainDatasetAdd3 := TStringField.Create(Self);
  MainDatasetCity := TStringField.Create(Self);
  MainDatasetPostCode := TStringField.Create(Self);
  MainDatasetEmail := TStringField.Create(Self);
  MainDatasetMobile := TStringField.Create(Self);
  MainDatasetTelephone := TStringField.Create(Self);
  MainDatasetMatchHash := TStringField.Create(Self);
  MainDatasetContactByPhone := TBooleanField.Create(Self);
  MainDatasetContactedByPost := TBooleanField.Create(Self);
  MainDatasetContactByText := TBooleanField.Create(Self);
  MainDatasetContactByEmail := TBooleanField.Create(Self);
  MainDatasetDOB := TDateField.Create(Self);
  MainDatasetHearingStatus := TStringField.Create(Self);
  MainDatasetEmailStatus := TStringField.Create(Self);
  MainDatasetLatitude := TFloatField.Create(Self);
  MainDatasetLongitude := TFloatField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetCountryCode := TStringField.Create(Self);
  MainDatasetVisualStatus := TStringField.Create(Self);
  MainDatasetMobilityStatus := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetImportState := TStringField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetImportBatchId := TIntegerField.Create(Self);
  MainDatasetSponsored := TBooleanField.Create(Self);
  MainDatasetDonationDate := TDateTimeField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetExternalDonationId := TStringField.Create(Self);
  MainDatasetMatchedPerson := TIntegerField.Create(Self);
  MainDatasetExternalDonationKind := TStringField.Create(Self);
  MainDatasetExternalDonorKind := TStringField.Create(Self);
  MainDatasetPaymentMethod := TStringField.Create(Self);
  MainDatasetPaymentMethodNote := TStringField.Create(Self);
  MainDatasetOtherDonationKind := TStringField.Create(Self);
  MainDatasetDonorResidence := TStringField.Create(Self);
  MainDatasetBankingDate := TDateTimeField.Create(Self);
  MainDatasetOrganisationName := TStringField.Create(Self);
  MainDatasetDonationClaimStatus := TStringField.Create(Self);
  MainDatasetComment := TStringField.Create(Self);
  MainDatasetAnalysisCode1 := TStringField.Create(Self);
  MainDatasetAnalysisCode2 := TStringField.Create(Self);
  MainDatasetAnalysisCode3 := TStringField.Create(Self);
  MainDatasetBankingReference := TStringField.Create(Self);
  MainDatasetBankingReference2 := TStringField.Create(Self);
  MainDatasetDeclarationDateSigned := TDateTimeField.Create(Self);
  MainDatasetDeclarationDateStarted := TDateTimeField.Create(Self);
  MainDatasetDeclarationClaimCoverage := TStringField.Create(Self);
  MainDatasetDeclarationMethod := TStringField.Create(Self);
  MainDatasetDeclarationStatus := TStringField.Create(Self);
  MainDatasetDeclarationId := TIntegerField.Create(Self);
  RefreshTimer := TTimer.Create(Self);
  WaitForBatchIdTimer := TTimer.Create(Self);
  WaitForBatchDataTimer := TTimer.Create(Self);
  NextRecordTimer := TTimer.Create(Self);
  EnableSaveButtonTimer := TTimer.Create(Self);
  DonorsDataset := TXDataWebDataSet.Create(Self);
  DonorsDatasetId := TIntegerField.Create(Self);
  DonorsDatasetDateAdded := TDateTimeField.Create(Self);
  DonorsDatasetAddedBy := TIntegerField.Create(Self);
  DonorsDatasetLastUpdatedBy := TIntegerField.Create(Self);
  DonorsDatasetLastUpdated := TDateTimeField.Create(Self);
  DonorsDatasetTitle := TStringField.Create(Self);
  DonorsDatasetFirstName := TStringField.Create(Self);
  DonorsDatasetMiddleName := TStringField.Create(Self);
  DonorsDatasetLastName := TStringField.Create(Self);
  DonorsDatasetSuffix := TStringField.Create(Self);
  DonorsDatasetAdd1 := TStringField.Create(Self);
  DonorsDatasetAdd2 := TStringField.Create(Self);
  DonorsDatasetAdd3 := TStringField.Create(Self);
  DonorsDatasetCity := TStringField.Create(Self);
  DonorsDatasetPostCode := TStringField.Create(Self);
  DonorsDatasetEmail := TStringField.Create(Self);
  DonorsDatasetMobile := TStringField.Create(Self);
  DonorsDatasetTelephone := TStringField.Create(Self);
  DonorsDatasetMatchHash := TStringField.Create(Self);
  DonorsDatasetContactByPhone := TBooleanField.Create(Self);
  DonorsDatasetContactByPost := TBooleanField.Create(Self);
  DonorsDatasetContactByText := TBooleanField.Create(Self);
  DonorsDatasetContactByEmail := TBooleanField.Create(Self);
  DonorsDatasetDOB := TDateField.Create(Self);
  DonorsDatasetHearingStatus := TStringField.Create(Self);
  DonorsDatasetEmailStatus := TStringField.Create(Self);
  DonorsDatasetLatitude := TFloatField.Create(Self);
  DonorsDatasetLongitude := TFloatField.Create(Self);
  DonorsDatasetExternalId := TStringField.Create(Self);
  DonorsDatasetCountryCode := TStringField.Create(Self);
  DonorsDatasetVisualStatus := TStringField.Create(Self);
  DonorsDatasetMobilityStatus := TStringField.Create(Self);
  DonorsDatasetSourceType := TStringField.Create(Self);
  DonorsDatasetClaimStatus := TStringField.Create(Self);
  DonorsDatasetCharityTenant := TStringField.Create(Self);
  DonorsDatasetSponsored := TBooleanField.Create(Self);
  DonorsDatasetMatchedPerson := TIntegerField.Create(Self);
  DonorsDatasetExternalDonationKind := TStringField.Create(Self);
  DonorsDatasetExternalDonorKind := TStringField.Create(Self);
  DonorsDatasetPaymentMethod := TStringField.Create(Self);
  DonorsDatasetPaymentMethodNote := TStringField.Create(Self);
  DonorsDatasetOtherDonationKind := TStringField.Create(Self);
  DonorsDatasetDonorResidence := TStringField.Create(Self);
  DonorsDatasetBankingDate := TDateTimeField.Create(Self);
  DonorsDatasetOrganisationName := TStringField.Create(Self);
  DonorsDatasetDateOfDeath := TDateTimeField.Create(Self);
  SearchDonorsDELETE := TTimer.Create(Self);
  ImportDataDataSource := TDataSource.Create(Self);
  DonationDefaults := TXDataWebDataSet.Create(Self);
  DonationDefaultsId := TIntegerField.Create(Self);
  DonationDefaultsDateAdded := TDateTimeField.Create(Self);
  DonationDefaultsAddedBy := TIntegerField.Create(Self);
  DonationDefaultsLastUpdatedBy := TIntegerField.Create(Self);
  DonationDefaultsLastUpdated := TDateTimeField.Create(Self);
  DonationDefaultsDonorId := TIntegerField.Create(Self);
  DonationDefaultsDonationKind := TStringField.Create(Self);
  DonationDefaultsUsualDayOfMonth := TIntegerField.Create(Self);
  DonationDefaultsAmount := TFloatField.Create(Self);
  DonationDefaultsPaymentMethod := TStringField.Create(Self);
  DonationDefaultsAnalysisCode1 := TStringField.Create(Self);
  DonationDefaultsAnalysisCode2 := TStringField.Create(Self);
  DonationDefaultsAnalysisCode3 := TStringField.Create(Self);
  DonationDefaultsBankingReference := TStringField.Create(Self);
  DonationDefaultsOtherDonationKind := TStringField.Create(Self);
  LookupsDataset := TXDataWebDataSet.Create(Self);
  AnalysisCode1 := TStringField.Create(Self);
  AnalysisCode2 := TStringField.Create(Self);
  LookupsDatasetBankingReference := TStringField.Create(Self);
  LookupsDataSource := TDataSource.Create(Self);

  MessageLabel.BeforeLoadDFMValues;
  DonationsData.BeforeLoadDFMValues;
  ErrorMessageTransactionDate.BeforeLoadDFMValues;
  lbBatchTotal.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataTable.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  SearchButton.BeforeLoadDFMValues;
  MergeButton.BeforeLoadDFMValues;
  ClearButton.BeforeLoadDFMValues;
  MessageDialog.BeforeLoadDFMValues;
  DuplicateDialog.BeforeLoadDFMValues;
  CountryList.BeforeLoadDFMValues;
  DeleteDonation.BeforeLoadDFMValues;
  DeleteDonor.BeforeLoadDFMValues;
  DonorSearchCombo.BeforeLoadDFMValues;
  TitleEdit.BeforeLoadDFMValues;
  FirstNameEdit.BeforeLoadDFMValues;
  LastNameEdit.BeforeLoadDFMValues;
  Add1Edit.BeforeLoadDFMValues;
  Add2Edit.BeforeLoadDFMValues;
  Add3Edit.BeforeLoadDFMValues;
  CityEdit.BeforeLoadDFMValues;
  PostCodeEdit.BeforeLoadDFMValues;
  AmountEdit.BeforeLoadDFMValues;
  DonationDateEdit.BeforeLoadDFMValues;
  SponsoredEdit.BeforeLoadDFMValues;
  DonationKindCombo.BeforeLoadDFMValues;
  OtherDonationKindEdit.BeforeLoadDFMValues;
  DonorKindCombo.BeforeLoadDFMValues;
  PaymentMethodNoteEdit.BeforeLoadDFMValues;
  DonorClaimStatusCombo.BeforeLoadDFMValues;
  OrganisationNameEdit.BeforeLoadDFMValues;
  PaymentMethodCombo.BeforeLoadDFMValues;
  ListWaitMessage.BeforeLoadDFMValues;
  DeclarationCombo.BeforeLoadDFMValues;
  DonationClaimStatus.BeforeLoadDFMValues;
  BankingDateEdit.BeforeLoadDFMValues;
  CommentMemo.BeforeLoadDFMValues;
  AnalysisCode1Combo.BeforeLoadDFMValues;
  AnalysisCode2Combo.BeforeLoadDFMValues;
  DonorDeclarationButton.BeforeLoadDFMValues;
  BankingReference2Edit.BeforeLoadDFMValues;
  BankingReferenceCombo.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetTitle.BeforeLoadDFMValues;
  MainDatasetFirstName.BeforeLoadDFMValues;
  MainDatasetMiddleName.BeforeLoadDFMValues;
  MainDatasetLastName.BeforeLoadDFMValues;
  MainDatasetSuffix.BeforeLoadDFMValues;
  MainDatasetAdd1.BeforeLoadDFMValues;
  MainDatasetAdd2.BeforeLoadDFMValues;
  MainDatasetAdd3.BeforeLoadDFMValues;
  MainDatasetCity.BeforeLoadDFMValues;
  MainDatasetPostCode.BeforeLoadDFMValues;
  MainDatasetEmail.BeforeLoadDFMValues;
  MainDatasetMobile.BeforeLoadDFMValues;
  MainDatasetTelephone.BeforeLoadDFMValues;
  MainDatasetMatchHash.BeforeLoadDFMValues;
  MainDatasetContactByPhone.BeforeLoadDFMValues;
  MainDatasetContactedByPost.BeforeLoadDFMValues;
  MainDatasetContactByText.BeforeLoadDFMValues;
  MainDatasetContactByEmail.BeforeLoadDFMValues;
  MainDatasetDOB.BeforeLoadDFMValues;
  MainDatasetHearingStatus.BeforeLoadDFMValues;
  MainDatasetEmailStatus.BeforeLoadDFMValues;
  MainDatasetLatitude.BeforeLoadDFMValues;
  MainDatasetLongitude.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetCountryCode.BeforeLoadDFMValues;
  MainDatasetVisualStatus.BeforeLoadDFMValues;
  MainDatasetMobilityStatus.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetImportState.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetImportBatchId.BeforeLoadDFMValues;
  MainDatasetSponsored.BeforeLoadDFMValues;
  MainDatasetDonationDate.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetExternalDonationId.BeforeLoadDFMValues;
  MainDatasetMatchedPerson.BeforeLoadDFMValues;
  MainDatasetExternalDonationKind.BeforeLoadDFMValues;
  MainDatasetExternalDonorKind.BeforeLoadDFMValues;
  MainDatasetPaymentMethod.BeforeLoadDFMValues;
  MainDatasetPaymentMethodNote.BeforeLoadDFMValues;
  MainDatasetOtherDonationKind.BeforeLoadDFMValues;
  MainDatasetDonorResidence.BeforeLoadDFMValues;
  MainDatasetBankingDate.BeforeLoadDFMValues;
  MainDatasetOrganisationName.BeforeLoadDFMValues;
  MainDatasetDonationClaimStatus.BeforeLoadDFMValues;
  MainDatasetComment.BeforeLoadDFMValues;
  MainDatasetAnalysisCode1.BeforeLoadDFMValues;
  MainDatasetAnalysisCode2.BeforeLoadDFMValues;
  MainDatasetAnalysisCode3.BeforeLoadDFMValues;
  MainDatasetBankingReference.BeforeLoadDFMValues;
  MainDatasetBankingReference2.BeforeLoadDFMValues;
  MainDatasetDeclarationDateSigned.BeforeLoadDFMValues;
  MainDatasetDeclarationDateStarted.BeforeLoadDFMValues;
  MainDatasetDeclarationClaimCoverage.BeforeLoadDFMValues;
  MainDatasetDeclarationMethod.BeforeLoadDFMValues;
  MainDatasetDeclarationStatus.BeforeLoadDFMValues;
  MainDatasetDeclarationId.BeforeLoadDFMValues;
  MainDataSource.BeforeLoadDFMValues;
  WebElementActionList1.BeforeLoadDFMValues;
  ListCloseTimer.BeforeLoadDFMValues;
  RefreshTimer.BeforeLoadDFMValues;
  WaitForBatchIdTimer.BeforeLoadDFMValues;
  WaitForBatchDataTimer.BeforeLoadDFMValues;
  NextRecordTimer.BeforeLoadDFMValues;
  EnableSaveButtonTimer.BeforeLoadDFMValues;
  DonorsDataset.BeforeLoadDFMValues;
  DonorsDatasetId.BeforeLoadDFMValues;
  DonorsDatasetDateAdded.BeforeLoadDFMValues;
  DonorsDatasetAddedBy.BeforeLoadDFMValues;
  DonorsDatasetLastUpdatedBy.BeforeLoadDFMValues;
  DonorsDatasetLastUpdated.BeforeLoadDFMValues;
  DonorsDatasetTitle.BeforeLoadDFMValues;
  DonorsDatasetFirstName.BeforeLoadDFMValues;
  DonorsDatasetMiddleName.BeforeLoadDFMValues;
  DonorsDatasetLastName.BeforeLoadDFMValues;
  DonorsDatasetSuffix.BeforeLoadDFMValues;
  DonorsDatasetAdd1.BeforeLoadDFMValues;
  DonorsDatasetAdd2.BeforeLoadDFMValues;
  DonorsDatasetAdd3.BeforeLoadDFMValues;
  DonorsDatasetCity.BeforeLoadDFMValues;
  DonorsDatasetPostCode.BeforeLoadDFMValues;
  DonorsDatasetEmail.BeforeLoadDFMValues;
  DonorsDatasetMobile.BeforeLoadDFMValues;
  DonorsDatasetTelephone.BeforeLoadDFMValues;
  DonorsDatasetMatchHash.BeforeLoadDFMValues;
  DonorsDatasetContactByPhone.BeforeLoadDFMValues;
  DonorsDatasetContactByPost.BeforeLoadDFMValues;
  DonorsDatasetContactByText.BeforeLoadDFMValues;
  DonorsDatasetContactByEmail.BeforeLoadDFMValues;
  DonorsDatasetDOB.BeforeLoadDFMValues;
  DonorsDatasetHearingStatus.BeforeLoadDFMValues;
  DonorsDatasetEmailStatus.BeforeLoadDFMValues;
  DonorsDatasetLatitude.BeforeLoadDFMValues;
  DonorsDatasetLongitude.BeforeLoadDFMValues;
  DonorsDatasetExternalId.BeforeLoadDFMValues;
  DonorsDatasetCountryCode.BeforeLoadDFMValues;
  DonorsDatasetVisualStatus.BeforeLoadDFMValues;
  DonorsDatasetMobilityStatus.BeforeLoadDFMValues;
  DonorsDatasetSourceType.BeforeLoadDFMValues;
  DonorsDatasetClaimStatus.BeforeLoadDFMValues;
  DonorsDatasetCharityTenant.BeforeLoadDFMValues;
  DonorsDatasetSponsored.BeforeLoadDFMValues;
  DonorsDatasetMatchedPerson.BeforeLoadDFMValues;
  DonorsDatasetExternalDonationKind.BeforeLoadDFMValues;
  DonorsDatasetExternalDonorKind.BeforeLoadDFMValues;
  DonorsDatasetPaymentMethod.BeforeLoadDFMValues;
  DonorsDatasetPaymentMethodNote.BeforeLoadDFMValues;
  DonorsDatasetOtherDonationKind.BeforeLoadDFMValues;
  DonorsDatasetDonorResidence.BeforeLoadDFMValues;
  DonorsDatasetBankingDate.BeforeLoadDFMValues;
  DonorsDatasetOrganisationName.BeforeLoadDFMValues;
  DonorsDatasetDateOfDeath.BeforeLoadDFMValues;
  SearchDonorsDELETE.BeforeLoadDFMValues;
  ImportDataDataSource.BeforeLoadDFMValues;
  DonationDefaults.BeforeLoadDFMValues;
  DonationDefaultsId.BeforeLoadDFMValues;
  DonationDefaultsDateAdded.BeforeLoadDFMValues;
  DonationDefaultsAddedBy.BeforeLoadDFMValues;
  DonationDefaultsLastUpdatedBy.BeforeLoadDFMValues;
  DonationDefaultsLastUpdated.BeforeLoadDFMValues;
  DonationDefaultsDonorId.BeforeLoadDFMValues;
  DonationDefaultsDonationKind.BeforeLoadDFMValues;
  DonationDefaultsUsualDayOfMonth.BeforeLoadDFMValues;
  DonationDefaultsAmount.BeforeLoadDFMValues;
  DonationDefaultsPaymentMethod.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode1.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode2.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode3.BeforeLoadDFMValues;
  DonationDefaultsBankingReference.BeforeLoadDFMValues;
  DonationDefaultsOtherDonationKind.BeforeLoadDFMValues;
  LookupsDataset.BeforeLoadDFMValues;
  AnalysisCode1.BeforeLoadDFMValues;
  AnalysisCode2.BeforeLoadDFMValues;
  LookupsDatasetBankingReference.BeforeLoadDFMValues;
  LookupsDataSource.BeforeLoadDFMValues;
  try
    Width := 1260;
    Height := 907;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    MessageLabel.Left := 1038;
    MessageLabel.Top := 488;
    DonationsData.SetParentComponent(Self);
    DonationsData.Name := 'DonationsData';
    DonationsData.Left := 24;
    DonationsData.Top := 584;
    DonationsData.Width := 119;
    DonationsData.Height := 25;
    DonationsData.Caption := 'DonationsData';
    DonationsData.ElementPosition := epIgnore;
    DonationsData.HeightStyle := ssAuto;
    DonationsData.HeightPercent := 100.000000000000000000;
    DonationsData.Visible := False;
    DonationsData.WidthStyle := ssAuto;
    DonationsData.WidthPercent := 100.000000000000000000;
    ErrorMessageTransactionDate.SetParentComponent(Self);
    ErrorMessageTransactionDate.Name := 'ErrorMessageTransactionDate';
    ErrorMessageTransactionDate.Left := 904;
    ErrorMessageTransactionDate.Top := 170;
    ErrorMessageTransactionDate.Width := 233;
    ErrorMessageTransactionDate.Height := 25;
    ErrorMessageTransactionDate.Caption := 'ErrorMessageTransactionDate';
    ErrorMessageTransactionDate.ElementPosition := epIgnore;
    ErrorMessageTransactionDate.HeightStyle := ssAuto;
    ErrorMessageTransactionDate.HeightPercent := 100.000000000000000000;
    ErrorMessageTransactionDate.WidthStyle := ssAuto;
    ErrorMessageTransactionDate.WidthPercent := 100.000000000000000000;
    lbBatchTotal.SetParentComponent(Self);
    lbBatchTotal.Name := 'lbBatchTotal';
    lbBatchTotal.Left := 8;
    lbBatchTotal.Top := 354;
    lbBatchTotal.Width := 126;
    lbBatchTotal.Height := 25;
    lbBatchTotal.Caption := 'Total Amount: '#163;
    lbBatchTotal.ElementFont := efCSS;
    lbBatchTotal.HeightPercent := 100.000000000000000000;
    lbBatchTotal.WidthPercent := 100.000000000000000000;
    cbPageSize.Left := 31;
    cbPageSize.Top := 377;
    edSearch.Left := 848;
    edSearch.Top := 482;
    edSearch.Visible := False;
    lcPaginator.Left := 200;
    lcPaginator.Top := 377;
    DataTable.Left := 31;
    DataTable.Top := 407;
    DataTable.Height := 158;
    DataTable.ElementClassName := 'table table-striped table-bordered  table-hover';
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonationDate';
      Title := 'Date';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Donor';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Address';
    end;
    with DataTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ImportState';
      Title := 'Record Status';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    AddButton.Left := 433;
    AddButton.Top := 580;
    AddButton.Enabled := False;
    SetEvent(AddButton, Self, 'OnClick', 'SaveDonationClick');
    SearchButton.Left := 975;
    SearchButton.Top := 478;
    SearchButton.Visible := False;
    MergeButton.SetParentComponent(Self);
    MergeButton.Name := 'MergeButton';
    MergeButton.Left := 331;
    MergeButton.Top := 581;
    MergeButton.Width := 96;
    MergeButton.Height := 24;
    MergeButton.Caption := 'Save';
    MergeButton.ChildOrder := 23;
    MergeButton.ElementClassName := 'btn';
    MergeButton.HeightPercent := 100.000000000000000000;
    MergeButton.WidthPercent := 100.000000000000000000;
    SetEvent(MergeButton, Self, 'OnClick', 'MergeButtonClick');
    ClearButton.SetParentComponent(Self);
    ClearButton.Name := 'ClearButton';
    ClearButton.Left := 229;
    ClearButton.Top := 580;
    ClearButton.Width := 96;
    ClearButton.Height := 25;
    ClearButton.Caption := 'Clear';
    ClearButton.ChildOrder := 24;
    ClearButton.ElementClassName := 'btn';
    ClearButton.Enabled := False;
    ClearButton.HeightPercent := 100.000000000000000000;
    ClearButton.WidthPercent := 100.000000000000000000;
    SetEvent(ClearButton, Self, 'OnClick', 'ClearButtonClick');
    MessageDialog.SetParentComponent(Self);
    MessageDialog.Name := 'MessageDialog';
    MessageDialog.Left := 1021;
    MessageDialog.Top := 201;
    MessageDialog.Width := 24;
    MessageDialog.Height := 24;
    MessageDialog.Buttons := [];
    MessageDialog.Opacity := 0.200000000000000000;
    DuplicateDialog.SetParentComponent(Self);
    DuplicateDialog.Name := 'DuplicateDialog';
    DuplicateDialog.Left := 992;
    DuplicateDialog.Top := 90;
    DuplicateDialog.Width := 24;
    DuplicateDialog.Height := 24;
    DuplicateDialog.HeightStyle := ssAuto;
    DuplicateDialog.WidthStyle := ssAuto;
    DuplicateDialog.Buttons := [];
    DuplicateDialog.Opacity := 0.200000000000000000;
    CountryList.SetParentComponent(Self);
    CountryList.Name := 'CountryList';
    CountryList.Left := 16;
    CountryList.Top := 320;
    CountryList.Width := 170;
    CountryList.Height := 33;
    CountryList.ElementClassName := 'form-select';
    CountryList.ElementPosition := epIgnore;
    CountryList.HeightPercent := 100.000000000000000000;
    CountryList.TabStop := False;
    CountryList.WidthStyle := ssAuto;
    CountryList.WidthPercent := 100.000000000000000000;
    SetEvent(CountryList, Self, 'OnChange', 'CountryListChange');
    CountryList.ItemIndex := -1;
    DeleteDonation.SetParentComponent(Self);
    DeleteDonation.Name := 'DeleteDonation';
    DeleteDonation.Left := 1057;
    DeleteDonation.Top := 146;
    DeleteDonation.Width := 24;
    DeleteDonation.Height := 24;
    DeleteDonation.HeightStyle := ssAuto;
    DeleteDonation.WidthStyle := ssAuto;
    DeleteDonation.Buttons := [mbYes,mbNo];
    DeleteDonation.DialogType := mtConfirmation;
    DeleteDonation.Opacity := 0.200000000000000000;
    DeleteDonation.ElementButtonClassName := 'btn';
    DeleteDonation.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    DeleteDonation.ElementTitleClassName := 'text-body';
    DeleteDonation.ElementContentClassName := 'text-body';
    DeleteDonor.SetParentComponent(Self);
    DeleteDonor.Name := 'DeleteDonor';
    DeleteDonor.Left := 1145;
    DeleteDonor.Top := 458;
    DeleteDonor.Width := 24;
    DeleteDonor.Height := 24;
    DeleteDonor.Buttons := [];
    DeleteDonor.Opacity := 0.200000000000000000;
    DeleteDonor.Visible := False;
    DonorSearchCombo.SetParentComponent(Self);
    DonorSearchCombo.Name := 'DonorSearchCombo';
    DonorSearchCombo.Left := 658;
    DonorSearchCombo.Top := 162;
    DonorSearchCombo.Width := 393;
    DonorSearchCombo.Height := 33;
    DonorSearchCombo.ElementClassName := 'form-select';
    DonorSearchCombo.ElementPosition := epIgnore;
    DonorSearchCombo.HeightStyle := ssAuto;
    DonorSearchCombo.HeightPercent := 100.000000000000000000;
    DonorSearchCombo.Style := csDropDown;
    DonorSearchCombo.WidthStyle := ssAuto;
    DonorSearchCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonorSearchCombo, Self, 'OnChange', 'DonorSearchComboChange');
    SetEvent(DonorSearchCombo, Self, 'OnClick', 'DonorSearchComboClick');
    DonorSearchCombo.ItemIndex := -1;
    TitleEdit.SetParentComponent(Self);
    TitleEdit.Name := 'TitleEdit';
    TitleEdit.Left := 192;
    TitleEdit.Top := 36;
    TitleEdit.Width := 121;
    TitleEdit.Height := 22;
    TitleEdit.ChildOrder := 32;
    TitleEdit.ElementClassName := 'form-control';
    TitleEdit.ElementPosition := epIgnore;
    TitleEdit.HeightStyle := ssAuto;
    TitleEdit.HeightPercent := 100.000000000000000000;
    TitleEdit.WidthStyle := ssAuto;
    TitleEdit.WidthPercent := 100.000000000000000000;
    SetEvent(TitleEdit, Self, 'OnExit', 'EditExit');
    FirstNameEdit.SetParentComponent(Self);
    FirstNameEdit.Name := 'FirstNameEdit';
    FirstNameEdit.Left := 192;
    FirstNameEdit.Top := 64;
    FirstNameEdit.Width := 121;
    FirstNameEdit.Height := 22;
    FirstNameEdit.ChildOrder := 32;
    FirstNameEdit.ElementClassName := 'form-control';
    FirstNameEdit.HeightPercent := 100.000000000000000000;
    FirstNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(FirstNameEdit, Self, 'OnChange', 'ValidateChange');
    SetEvent(FirstNameEdit, Self, 'OnExit', 'EditExit');
    LastNameEdit.SetParentComponent(Self);
    LastNameEdit.Name := 'LastNameEdit';
    LastNameEdit.Left := 192;
    LastNameEdit.Top := 92;
    LastNameEdit.Width := 121;
    LastNameEdit.Height := 22;
    LastNameEdit.ChildOrder := 32;
    LastNameEdit.ElementClassName := 'form-control';
    LastNameEdit.HeightPercent := 100.000000000000000000;
    LastNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(LastNameEdit, Self, 'OnChange', 'ValidateChange');
    SetEvent(LastNameEdit, Self, 'OnExit', 'EditExit');
    Add1Edit.SetParentComponent(Self);
    Add1Edit.Name := 'Add1Edit';
    Add1Edit.Left := 192;
    Add1Edit.Top := 120;
    Add1Edit.Width := 121;
    Add1Edit.Height := 22;
    Add1Edit.ChildOrder := 32;
    Add1Edit.ElementPosition := epIgnore;
    Add1Edit.HeightStyle := ssAuto;
    Add1Edit.HeightPercent := 100.000000000000000000;
    Add1Edit.WidthStyle := ssAuto;
    Add1Edit.WidthPercent := 100.000000000000000000;
    SetEvent(Add1Edit, Self, 'OnChange', 'ValidateChange');
    Add2Edit.SetParentComponent(Self);
    Add2Edit.Name := 'Add2Edit';
    Add2Edit.Left := 192;
    Add2Edit.Top := 148;
    Add2Edit.Width := 121;
    Add2Edit.Height := 22;
    Add2Edit.ChildOrder := 32;
    Add2Edit.ElementPosition := epIgnore;
    Add2Edit.HeightStyle := ssAuto;
    Add2Edit.HeightPercent := 100.000000000000000000;
    Add2Edit.WidthStyle := ssAuto;
    Add2Edit.WidthPercent := 100.000000000000000000;
    Add3Edit.SetParentComponent(Self);
    Add3Edit.Name := 'Add3Edit';
    Add3Edit.Left := 192;
    Add3Edit.Top := 176;
    Add3Edit.Width := 121;
    Add3Edit.Height := 22;
    Add3Edit.ChildOrder := 32;
    Add3Edit.ElementPosition := epIgnore;
    Add3Edit.HeightStyle := ssAuto;
    Add3Edit.HeightPercent := 100.000000000000000000;
    Add3Edit.WidthStyle := ssAuto;
    Add3Edit.WidthPercent := 100.000000000000000000;
    CityEdit.SetParentComponent(Self);
    CityEdit.Name := 'CityEdit';
    CityEdit.Left := 192;
    CityEdit.Top := 204;
    CityEdit.Width := 121;
    CityEdit.Height := 22;
    CityEdit.ChildOrder := 32;
    CityEdit.ElementPosition := epIgnore;
    CityEdit.HeightStyle := ssAuto;
    CityEdit.HeightPercent := 100.000000000000000000;
    CityEdit.WidthStyle := ssAuto;
    CityEdit.WidthPercent := 100.000000000000000000;
    PostCodeEdit.SetParentComponent(Self);
    PostCodeEdit.Name := 'PostCodeEdit';
    PostCodeEdit.Left := 192;
    PostCodeEdit.Top := 236;
    PostCodeEdit.Width := 121;
    PostCodeEdit.Height := 22;
    PostCodeEdit.ChildOrder := 32;
    PostCodeEdit.ElementPosition := epIgnore;
    PostCodeEdit.HeightStyle := ssAuto;
    PostCodeEdit.HeightPercent := 100.000000000000000000;
    PostCodeEdit.WidthStyle := ssAuto;
    PostCodeEdit.WidthPercent := 100.000000000000000000;
    SetEvent(PostCodeEdit, Self, 'OnChange', 'PostCodeEditChange');
    SetEvent(PostCodeEdit, Self, 'OnExit', 'PostCodeEditExit');
    AmountEdit.SetParentComponent(Self);
    AmountEdit.Name := 'AmountEdit';
    AmountEdit.Left := 192;
    AmountEdit.Top := 292;
    AmountEdit.Width := 121;
    AmountEdit.Height := 22;
    AmountEdit.ChildOrder := 32;
    AmountEdit.ElementPosition := epIgnore;
    AmountEdit.HeightStyle := ssAuto;
    AmountEdit.HeightPercent := 100.000000000000000000;
    AmountEdit.WidthStyle := ssAuto;
    AmountEdit.WidthPercent := 100.000000000000000000;
    SetEvent(AmountEdit, Self, 'OnChange', 'ValidateChange');
    SetEvent(AmountEdit, Self, 'OnKeyPress', 'AmountEditKeyPress');
    DonationDateEdit.SetParentComponent(Self);
    DonationDateEdit.Name := 'DonationDateEdit';
    DonationDateEdit.Left := 192;
    DonationDateEdit.Top := 264;
    DonationDateEdit.Width := 170;
    DonationDateEdit.Height := 22;
    DonationDateEdit.ElementClassName := 'form-control';
    DonationDateEdit.HeightStyle := ssAuto;
    DonationDateEdit.WidthStyle := ssAuto;
    DonationDateEdit.BorderStyle := bsNone;
    DonationDateEdit.ChildOrder := 42;
    DonationDateEdit.Color := clWhite;
    DonationDateEdit.Date := 45939.376992129630000000;
    DonationDateEdit.ElementPosition := epIgnore;
    DonationDateEdit.Role := '';
    DonationDateEdit.Text := 'dd/mm/yyyy';
    SetEvent(DonationDateEdit, Self, 'OnChange', 'DonationDateEditChange');
    SetEvent(DonationDateEdit, Self, 'OnExit', 'DonationDateEditChange');
    SponsoredEdit.SetParentComponent(Self);
    SponsoredEdit.Name := 'SponsoredEdit';
    SponsoredEdit.Left := 192;
    SponsoredEdit.Top := 352;
    SponsoredEdit.Width := 113;
    SponsoredEdit.Height := 22;
    SponsoredEdit.Caption := 'Sponsored';
    SponsoredEdit.ChildOrder := 43;
    SponsoredEdit.ElementClassName := 'custom-control custom-checkbox';
    SponsoredEdit.ElementButtonClassName := 'custom-control-input';
    SponsoredEdit.ElementLabelClassName := 'custom-control-label';
    SponsoredEdit.HeightStyle := ssAuto;
    SponsoredEdit.HeightPercent := 100.000000000000000000;
    SponsoredEdit.WidthStyle := ssAuto;
    SponsoredEdit.WidthPercent := 100.000000000000000000;
    DonationKindCombo.SetParentComponent(Self);
    DonationKindCombo.Name := 'DonationKindCombo';
    DonationKindCombo.Left := 24;
    DonationKindCombo.Top := 660;
    DonationKindCombo.Width := 145;
    DonationKindCombo.Height := 22;
    DonationKindCombo.ElementClassName := 'form-select';
    DonationKindCombo.ElementPosition := epIgnore;
    DonationKindCombo.HeightStyle := ssAuto;
    DonationKindCombo.HeightPercent := 100.000000000000000000;
    DonationKindCombo.WidthStyle := ssAuto;
    DonationKindCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonationKindCombo, Self, 'OnChange', 'DonationKindComboChange');
    SetEvent(DonationKindCombo, Self, 'OnExit', 'DonationKindComboExit');
    DonationKindCombo.ItemIndex := -1;
    OtherDonationKindEdit.SetParentComponent(Self);
    OtherDonationKindEdit.Name := 'OtherDonationKindEdit';
    OtherDonationKindEdit.Left := 24;
    OtherDonationKindEdit.Top := 688;
    OtherDonationKindEdit.Width := 504;
    OtherDonationKindEdit.Height := 22;
    OtherDonationKindEdit.ChildOrder := 45;
    OtherDonationKindEdit.ElementClassName := 'form-control';
    OtherDonationKindEdit.ElementPosition := epIgnore;
    OtherDonationKindEdit.Enabled := False;
    OtherDonationKindEdit.HeightStyle := ssAuto;
    OtherDonationKindEdit.HeightPercent := 100.000000000000000000;
    OtherDonationKindEdit.WidthStyle := ssAuto;
    OtherDonationKindEdit.WidthPercent := 100.000000000000000000;
    DonorKindCombo.SetParentComponent(Self);
    DonorKindCombo.Name := 'DonorKindCombo';
    DonorKindCombo.Left := 24;
    DonorKindCombo.Top := 720;
    DonorKindCombo.Width := 145;
    DonorKindCombo.Height := 22;
    DonorKindCombo.ElementClassName := 'form-select';
    DonorKindCombo.ElementPosition := epIgnore;
    DonorKindCombo.HeightStyle := ssAuto;
    DonorKindCombo.HeightPercent := 100.000000000000000000;
    DonorKindCombo.WidthStyle := ssAuto;
    DonorKindCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonorKindCombo, Self, 'OnChange', 'ValidateChange');
    DonorKindCombo.ItemIndex := -1;
    PaymentMethodNoteEdit.SetParentComponent(Self);
    PaymentMethodNoteEdit.Name := 'PaymentMethodNoteEdit';
    PaymentMethodNoteEdit.Left := 24;
    PaymentMethodNoteEdit.Top := 808;
    PaymentMethodNoteEdit.Width := 504;
    PaymentMethodNoteEdit.Height := 22;
    PaymentMethodNoteEdit.ChildOrder := 45;
    PaymentMethodNoteEdit.ElementClassName := 'form-control';
    PaymentMethodNoteEdit.ElementPosition := epIgnore;
    PaymentMethodNoteEdit.HeightStyle := ssAuto;
    PaymentMethodNoteEdit.HeightPercent := 100.000000000000000000;
    PaymentMethodNoteEdit.WidthStyle := ssAuto;
    PaymentMethodNoteEdit.WidthPercent := 100.000000000000000000;
    DonorClaimStatusCombo.SetParentComponent(Self);
    DonorClaimStatusCombo.Name := 'DonorClaimStatusCombo';
    DonorClaimStatusCombo.Left := 24;
    DonorClaimStatusCombo.Top := 849;
    DonorClaimStatusCombo.Width := 145;
    DonorClaimStatusCombo.Height := 22;
    DonorClaimStatusCombo.ElementClassName := 'form-select';
    DonorClaimStatusCombo.ElementPosition := epIgnore;
    DonorClaimStatusCombo.HeightStyle := ssAuto;
    DonorClaimStatusCombo.HeightPercent := 100.000000000000000000;
    DonorClaimStatusCombo.WidthStyle := ssAuto;
    DonorClaimStatusCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonorClaimStatusCombo, Self, 'OnChange', 'DonorClaimStatusComboChange');
    DonorClaimStatusCombo.ItemIndex := -1;
    OrganisationNameEdit.SetParentComponent(Self);
    OrganisationNameEdit.Name := 'OrganisationNameEdit';
    OrganisationNameEdit.Left := 368;
    OrganisationNameEdit.Top := 320;
    OrganisationNameEdit.Width := 504;
    OrganisationNameEdit.Height := 22;
    OrganisationNameEdit.ChildOrder := 45;
    OrganisationNameEdit.ElementClassName := 'form-control';
    OrganisationNameEdit.ElementPosition := epIgnore;
    OrganisationNameEdit.HeightStyle := ssAuto;
    OrganisationNameEdit.HeightPercent := 100.000000000000000000;
    OrganisationNameEdit.Text := 'Org';
    OrganisationNameEdit.WidthStyle := ssAuto;
    OrganisationNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(OrganisationNameEdit, Self, 'OnChange', 'ValidateChange');
    PaymentMethodCombo.SetParentComponent(Self);
    PaymentMethodCombo.Name := 'PaymentMethodCombo';
    PaymentMethodCombo.Left := 24;
    PaymentMethodCombo.Top := 776;
    PaymentMethodCombo.Width := 145;
    PaymentMethodCombo.Height := 22;
    PaymentMethodCombo.ElementClassName := 'form-select';
    PaymentMethodCombo.ElementPosition := epIgnore;
    PaymentMethodCombo.HeightStyle := ssAuto;
    PaymentMethodCombo.HeightPercent := 100.000000000000000000;
    PaymentMethodCombo.WidthStyle := ssAuto;
    PaymentMethodCombo.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodCombo, Self, 'OnChange', 'PaymentMethodComboChange');
    SetEvent(PaymentMethodCombo, Self, 'OnExit', 'PaymentMethodComboExit');
    PaymentMethodCombo.ItemIndex := -1;
    ListWaitMessage.Left := 968;
    ListWaitMessage.Top := 406;
    DeclarationCombo.SetParentComponent(Self);
    DeclarationCombo.Name := 'DeclarationCombo';
    DeclarationCombo.Left := 368;
    DeclarationCombo.Top := 281;
    DeclarationCombo.Width := 417;
    DeclarationCombo.Height := 33;
    DeclarationCombo.ElementClassName := 'form-select';
    DeclarationCombo.ElementPosition := epIgnore;
    DeclarationCombo.HeightStyle := ssAuto;
    DeclarationCombo.HeightPercent := 100.000000000000000000;
    DeclarationCombo.WidthStyle := ssAuto;
    DeclarationCombo.WidthPercent := 100.000000000000000000;
    DeclarationCombo.ItemIndex := -1;
    DonationClaimStatus.SetParentComponent(Self);
    DonationClaimStatus.Name := 'DonationClaimStatus';
    DonationClaimStatus.Left := 24;
    DonationClaimStatus.Top := 632;
    DonationClaimStatus.Width := 145;
    DonationClaimStatus.Height := 22;
    DonationClaimStatus.ElementClassName := 'form-select';
    DonationClaimStatus.ElementPosition := epIgnore;
    DonationClaimStatus.HeightStyle := ssAuto;
    DonationClaimStatus.HeightPercent := 100.000000000000000000;
    DonationClaimStatus.WidthStyle := ssAuto;
    DonationClaimStatus.WidthPercent := 100.000000000000000000;
    SetEvent(DonationClaimStatus, Self, 'OnChange', 'DonationKindComboChange');
    SetEvent(DonationClaimStatus, Self, 'OnExit', 'DonationKindComboExit');
    DonationClaimStatus.ItemIndex := -1;
    BankingDateEdit.SetParentComponent(Self);
    BankingDateEdit.Name := 'BankingDateEdit';
    BankingDateEdit.Left := 192;
    BankingDateEdit.Top := 768;
    BankingDateEdit.Width := 170;
    BankingDateEdit.Height := 22;
    BankingDateEdit.ElementClassName := 'form-control';
    BankingDateEdit.HeightStyle := ssAuto;
    BankingDateEdit.WidthStyle := ssAuto;
    BankingDateEdit.BorderStyle := bsNone;
    BankingDateEdit.ChildOrder := 42;
    BankingDateEdit.Color := clWhite;
    BankingDateEdit.Date := 45939.376992129630000000;
    BankingDateEdit.ElementPosition := epIgnore;
    BankingDateEdit.Role := '';
    BankingDateEdit.Text := 'dd/mm/yyyy';
    SetEvent(BankingDateEdit, Self, 'OnChange', 'DonationDateEditChange');
    CommentMemo.SetParentComponent(Self);
    CommentMemo.Name := 'CommentMemo';
    CommentMemo.Left := 550;
    CommentMemo.Top := 581;
    CommentMemo.Width := 419;
    CommentMemo.Height := 196;
    CommentMemo.ElementClassName := 'form-control';
    CommentMemo.ElementPosition := epIgnore;
    CommentMemo.HeightStyle := ssAuto;
    CommentMemo.HeightPercent := 100.000000000000000000;
    CommentMemo.SelLength := 0;
    CommentMemo.SelStart := 0;
    CommentMemo.WidthStyle := ssAuto;
    CommentMemo.WidthPercent := 100.000000000000000000;
    AnalysisCode1Combo.SetParentComponent(Self);
    AnalysisCode1Combo.Name := 'AnalysisCode1Combo';
    AnalysisCode1Combo.Left := 550;
    AnalysisCode1Combo.Top := 504;
    AnalysisCode1Combo.Width := 267;
    AnalysisCode1Combo.Height := 33;
    AnalysisCode1Combo.HeightPercent := 100.000000000000000000;
    AnalysisCode1Combo.WidthPercent := 100.000000000000000000;
    AnalysisCode1Combo.ItemIndex := -1;
    AnalysisCode1Combo.DataField := 'AnalysisCode1';
    AnalysisCode1Combo.DataSource := LookupsDataSource;
    AnalysisCode2Combo.SetParentComponent(Self);
    AnalysisCode2Combo.Name := 'AnalysisCode2Combo';
    AnalysisCode2Combo.Left := 550;
    AnalysisCode2Combo.Top := 533;
    AnalysisCode2Combo.Width := 267;
    AnalysisCode2Combo.Height := 33;
    AnalysisCode2Combo.HeightPercent := 100.000000000000000000;
    AnalysisCode2Combo.Text := 'AnalysisCode2Combo';
    AnalysisCode2Combo.WidthPercent := 100.000000000000000000;
    AnalysisCode2Combo.ItemIndex := -1;
    AnalysisCode2Combo.DataField := 'AnalysisCode2';
    AnalysisCode2Combo.DataSource := LookupsDataSource;
    DonorDeclarationButton.SetParentComponent(Self);
    DonorDeclarationButton.Name := 'DonorDeclarationButton';
    DonorDeclarationButton.Left := 552;
    DonorDeclarationButton.Top := 809;
    DonorDeclarationButton.Width := 33;
    DonorDeclarationButton.Height := 25;
    DonorDeclarationButton.Caption := '+';
    DonorDeclarationButton.ChildOrder := 44;
    DonorDeclarationButton.ElementClassName := 'btn';
    DonorDeclarationButton.ElementPosition := epIgnore;
    DonorDeclarationButton.HeightStyle := ssAuto;
    DonorDeclarationButton.HeightPercent := 100.000000000000000000;
    DonorDeclarationButton.WidthStyle := ssAuto;
    DonorDeclarationButton.WidthPercent := 100.000000000000000000;
    SetEvent(DonorDeclarationButton, Self, 'OnClick', 'DonorDeclarationButtonClick');
    BankingReference2Edit.SetParentComponent(Self);
    BankingReference2Edit.Name := 'BankingReference2Edit';
    BankingReference2Edit.Left := 552;
    BankingReference2Edit.Top := 868;
    BankingReference2Edit.Width := 289;
    BankingReference2Edit.Height := 22;
    BankingReference2Edit.ChildOrder := 45;
    BankingReference2Edit.ElementClassName := 'form-control';
    BankingReference2Edit.ElementPosition := epIgnore;
    BankingReference2Edit.HeightStyle := ssAuto;
    BankingReference2Edit.HeightPercent := 100.000000000000000000;
    BankingReference2Edit.WidthStyle := ssAuto;
    BankingReference2Edit.WidthPercent := 100.000000000000000000;
    BankingReferenceCombo.SetParentComponent(Self);
    BankingReferenceCombo.Name := 'BankingReferenceCombo';
    BankingReferenceCombo.Left := 552;
    BankingReferenceCombo.Top := 840;
    BankingReferenceCombo.Width := 289;
    BankingReferenceCombo.Height := 33;
    BankingReferenceCombo.ElementClassName := 'form-select';
    BankingReferenceCombo.HeightPercent := 100.000000000000000000;
    BankingReferenceCombo.Text := 'BankingReferenceCombo';
    BankingReferenceCombo.WidthPercent := 100.000000000000000000;
    SetEvent(BankingReferenceCombo, Self, 'OnChange', 'BankingReferenceComboChange');
    BankingReferenceCombo.ItemIndex := -1;
    BankingReferenceCombo.DataField := 'BankingReference';
    BankingReferenceCombo.DataSource := LookupsDataSource;
    MainDataset.AfterApplyUpdates := MainDatasetAfterApplyUpdates;
    MainDataset.AfterDelete := MainDatasetAfterDelete;
    MainDataset.EntitySetName := 'ImportDonation';
    MainDataset.Left := 728;
    MainDataset.Top := 98;
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetTitle.SetParentComponent(MainDataset);
    MainDatasetTitle.Name := 'MainDatasetTitle';
    MainDatasetTitle.FieldName := 'Title';
    MainDatasetTitle.Size := 25;
    MainDatasetFirstName.SetParentComponent(MainDataset);
    MainDatasetFirstName.Name := 'MainDatasetFirstName';
    MainDatasetFirstName.FieldName := 'FirstName';
    MainDatasetFirstName.Size := 50;
    MainDatasetMiddleName.SetParentComponent(MainDataset);
    MainDatasetMiddleName.Name := 'MainDatasetMiddleName';
    MainDatasetMiddleName.FieldName := 'MiddleName';
    MainDatasetMiddleName.Size := 50;
    MainDatasetLastName.SetParentComponent(MainDataset);
    MainDatasetLastName.Name := 'MainDatasetLastName';
    MainDatasetLastName.FieldName := 'LastName';
    MainDatasetLastName.Size := 50;
    MainDatasetSuffix.SetParentComponent(MainDataset);
    MainDatasetSuffix.Name := 'MainDatasetSuffix';
    MainDatasetSuffix.FieldName := 'Suffix';
    MainDatasetSuffix.Size := 50;
    MainDatasetAdd1.SetParentComponent(MainDataset);
    MainDatasetAdd1.Name := 'MainDatasetAdd1';
    MainDatasetAdd1.FieldName := 'Add1';
    MainDatasetAdd1.Size := 75;
    MainDatasetAdd2.SetParentComponent(MainDataset);
    MainDatasetAdd2.Name := 'MainDatasetAdd2';
    MainDatasetAdd2.FieldName := 'Add2';
    MainDatasetAdd2.Size := 75;
    MainDatasetAdd3.SetParentComponent(MainDataset);
    MainDatasetAdd3.Name := 'MainDatasetAdd3';
    MainDatasetAdd3.FieldName := 'Add3';
    MainDatasetAdd3.Size := 75;
    MainDatasetCity.SetParentComponent(MainDataset);
    MainDatasetCity.Name := 'MainDatasetCity';
    MainDatasetCity.FieldName := 'City';
    MainDatasetCity.Size := 75;
    MainDatasetPostCode.SetParentComponent(MainDataset);
    MainDatasetPostCode.Name := 'MainDatasetPostCode';
    MainDatasetPostCode.FieldName := 'PostCode';
    MainDatasetPostCode.Size := 15;
    MainDatasetEmail.SetParentComponent(MainDataset);
    MainDatasetEmail.Name := 'MainDatasetEmail';
    MainDatasetEmail.FieldName := 'Email';
    MainDatasetEmail.Size := 75;
    MainDatasetMobile.SetParentComponent(MainDataset);
    MainDatasetMobile.Name := 'MainDatasetMobile';
    MainDatasetMobile.FieldName := 'Mobile';
    MainDatasetMobile.Size := 25;
    MainDatasetTelephone.SetParentComponent(MainDataset);
    MainDatasetTelephone.Name := 'MainDatasetTelephone';
    MainDatasetTelephone.FieldName := 'Telephone';
    MainDatasetTelephone.Size := 25;
    MainDatasetMatchHash.SetParentComponent(MainDataset);
    MainDatasetMatchHash.Name := 'MainDatasetMatchHash';
    MainDatasetMatchHash.FieldName := 'MatchHash';
    MainDatasetMatchHash.Size := 64;
    MainDatasetContactByPhone.SetParentComponent(MainDataset);
    MainDatasetContactByPhone.Name := 'MainDatasetContactByPhone';
    MainDatasetContactByPhone.FieldName := 'ContactByPhone';
    MainDatasetContactedByPost.SetParentComponent(MainDataset);
    MainDatasetContactedByPost.Name := 'MainDatasetContactedByPost';
    MainDatasetContactedByPost.FieldName := 'ContactByPost';
    MainDatasetContactByText.SetParentComponent(MainDataset);
    MainDatasetContactByText.Name := 'MainDatasetContactByText';
    MainDatasetContactByText.FieldName := 'ContactByText';
    MainDatasetContactByEmail.SetParentComponent(MainDataset);
    MainDatasetContactByEmail.Name := 'MainDatasetContactByEmail';
    MainDatasetContactByEmail.FieldName := 'ContactByEmail';
    MainDatasetDOB.SetParentComponent(MainDataset);
    MainDatasetDOB.Name := 'MainDatasetDOB';
    MainDatasetDOB.FieldName := 'DOB';
    MainDatasetHearingStatus.SetParentComponent(MainDataset);
    MainDatasetHearingStatus.Name := 'MainDatasetHearingStatus';
    MainDatasetHearingStatus.FieldName := 'HearingStatus';
    MainDatasetHearingStatus.Size := 8;
    MainDatasetEmailStatus.SetParentComponent(MainDataset);
    MainDatasetEmailStatus.Name := 'MainDatasetEmailStatus';
    MainDatasetEmailStatus.FieldName := 'EmailStatus';
    MainDatasetEmailStatus.Size := 10;
    MainDatasetLatitude.SetParentComponent(MainDataset);
    MainDatasetLatitude.Name := 'MainDatasetLatitude';
    MainDatasetLatitude.FieldName := 'Latitude';
    MainDatasetLongitude.SetParentComponent(MainDataset);
    MainDatasetLongitude.Name := 'MainDatasetLongitude';
    MainDatasetLongitude.FieldName := 'Longitude';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 64;
    MainDatasetCountryCode.SetParentComponent(MainDataset);
    MainDatasetCountryCode.Name := 'MainDatasetCountryCode';
    MainDatasetCountryCode.FieldName := 'CountryCode';
    MainDatasetCountryCode.Size := 3;
    MainDatasetVisualStatus.SetParentComponent(MainDataset);
    MainDatasetVisualStatus.Name := 'MainDatasetVisualStatus';
    MainDatasetVisualStatus.FieldName := 'VisualStatus';
    MainDatasetVisualStatus.Size := 8;
    MainDatasetMobilityStatus.SetParentComponent(MainDataset);
    MainDatasetMobilityStatus.Name := 'MainDatasetMobilityStatus';
    MainDatasetMobilityStatus.FieldName := 'MobilityStatus';
    MainDatasetMobilityStatus.Size := 8;
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 19;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetImportState.SetParentComponent(MainDataset);
    MainDatasetImportState.Name := 'MainDatasetImportState';
    MainDatasetImportState.FieldName := 'ImportState';
    MainDatasetImportState.Size := 5;
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetImportBatchId.SetParentComponent(MainDataset);
    MainDatasetImportBatchId.Name := 'MainDatasetImportBatchId';
    MainDatasetImportBatchId.FieldName := 'ImportBatchId';
    MainDatasetSponsored.SetParentComponent(MainDataset);
    MainDatasetSponsored.Name := 'MainDatasetSponsored';
    MainDatasetSponsored.FieldName := 'Sponsored';
    MainDatasetDonationDate.SetParentComponent(MainDataset);
    MainDatasetDonationDate.Name := 'MainDatasetDonationDate';
    MainDatasetDonationDate.FieldName := 'DonationDate';
    MainDatasetDonationDate.DisplayFormat := 'DD/MM/YYYY';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.Alignment := taCenter;
    MainDatasetAmount.FieldName := 'Amount';
    SetEvent(MainDatasetAmount, Self, 'OnGetText', 'MainDatasetAmountGetText');
    MainDatasetExternalDonationId.SetParentComponent(MainDataset);
    MainDatasetExternalDonationId.Name := 'MainDatasetExternalDonationId';
    MainDatasetExternalDonationId.FieldName := 'ExternalDonationId';
    MainDatasetExternalDonationId.Size := 255;
    MainDatasetMatchedPerson.SetParentComponent(MainDataset);
    MainDatasetMatchedPerson.Name := 'MainDatasetMatchedPerson';
    MainDatasetMatchedPerson.FieldName := 'MatchedPerson';
    MainDatasetExternalDonationKind.SetParentComponent(MainDataset);
    MainDatasetExternalDonationKind.Name := 'MainDatasetExternalDonationKind';
    MainDatasetExternalDonationKind.FieldName := 'DonationKind';
    MainDatasetExternalDonationKind.Size := 30;
    MainDatasetExternalDonorKind.SetParentComponent(MainDataset);
    MainDatasetExternalDonorKind.Name := 'MainDatasetExternalDonorKind';
    MainDatasetExternalDonorKind.FieldName := 'DonorKind';
    MainDatasetExternalDonorKind.Size := 30;
    MainDatasetPaymentMethod.SetParentComponent(MainDataset);
    MainDatasetPaymentMethod.Name := 'MainDatasetPaymentMethod';
    MainDatasetPaymentMethod.FieldName := 'PaymentMethod';
    MainDatasetPaymentMethod.Size := 30;
    MainDatasetPaymentMethodNote.SetParentComponent(MainDataset);
    MainDatasetPaymentMethodNote.Name := 'MainDatasetPaymentMethodNote';
    MainDatasetPaymentMethodNote.FieldName := 'PaymentMethodNote';
    MainDatasetPaymentMethodNote.Size := 75;
    MainDatasetOtherDonationKind.SetParentComponent(MainDataset);
    MainDatasetOtherDonationKind.Name := 'MainDatasetOtherDonationKind';
    MainDatasetOtherDonationKind.FieldName := 'OtherDonationKind';
    MainDatasetOtherDonationKind.Size := 100;
    MainDatasetDonorResidence.SetParentComponent(MainDataset);
    MainDatasetDonorResidence.Name := 'MainDatasetDonorResidence';
    MainDatasetDonorResidence.FieldName := 'DonorResidence';
    MainDatasetDonorResidence.Size := 100;
    MainDatasetBankingDate.SetParentComponent(MainDataset);
    MainDatasetBankingDate.Name := 'MainDatasetBankingDate';
    MainDatasetBankingDate.FieldName := 'BankingDate';
    MainDatasetOrganisationName.SetParentComponent(MainDataset);
    MainDatasetOrganisationName.Name := 'MainDatasetOrganisationName';
    MainDatasetOrganisationName.FieldName := 'OrganisationName';
    MainDatasetOrganisationName.Size := 250;
    MainDatasetDonationClaimStatus.SetParentComponent(MainDataset);
    MainDatasetDonationClaimStatus.Name := 'MainDatasetDonationClaimStatus';
    MainDatasetDonationClaimStatus.FieldName := 'DonationClaimStatus';
    MainDatasetComment.SetParentComponent(MainDataset);
    MainDatasetComment.Name := 'MainDatasetComment';
    MainDatasetComment.FieldName := 'Comment';
    MainDatasetComment.Size := 2048;
    MainDatasetAnalysisCode1.SetParentComponent(MainDataset);
    MainDatasetAnalysisCode1.Name := 'MainDatasetAnalysisCode1';
    MainDatasetAnalysisCode1.FieldName := 'AnalysisCode1';
    MainDatasetAnalysisCode1.Size := 64;
    MainDatasetAnalysisCode2.SetParentComponent(MainDataset);
    MainDatasetAnalysisCode2.Name := 'MainDatasetAnalysisCode2';
    MainDatasetAnalysisCode2.FieldName := 'AnalysisCode2';
    MainDatasetAnalysisCode2.Size := 64;
    MainDatasetAnalysisCode3.SetParentComponent(MainDataset);
    MainDatasetAnalysisCode3.Name := 'MainDatasetAnalysisCode3';
    MainDatasetAnalysisCode3.FieldName := 'AnalysisCode3';
    MainDatasetAnalysisCode3.Size := 64;
    MainDatasetBankingReference.SetParentComponent(MainDataset);
    MainDatasetBankingReference.Name := 'MainDatasetBankingReference';
    MainDatasetBankingReference.FieldName := 'BankingReference';
    MainDatasetBankingReference.Size := 25;
    MainDatasetBankingReference2.SetParentComponent(MainDataset);
    MainDatasetBankingReference2.Name := 'MainDatasetBankingReference2';
    MainDatasetBankingReference2.FieldName := 'BankingReference2';
    MainDatasetBankingReference2.Size := 25;
    MainDatasetDeclarationDateSigned.SetParentComponent(MainDataset);
    MainDatasetDeclarationDateSigned.Name := 'MainDatasetDeclarationDateSigned';
    MainDatasetDeclarationDateSigned.FieldName := 'DeclarationDateSigned';
    MainDatasetDeclarationDateStarted.SetParentComponent(MainDataset);
    MainDatasetDeclarationDateStarted.Name := 'MainDatasetDeclarationDateStarted';
    MainDatasetDeclarationDateStarted.FieldName := 'DeclarationDateStarted';
    MainDatasetDeclarationClaimCoverage.SetParentComponent(MainDataset);
    MainDatasetDeclarationClaimCoverage.Name := 'MainDatasetDeclarationClaimCoverage';
    MainDatasetDeclarationClaimCoverage.FieldName := 'DeclarationClaimCoverage';
    MainDatasetDeclarationClaimCoverage.Size := 6;
    MainDatasetDeclarationMethod.SetParentComponent(MainDataset);
    MainDatasetDeclarationMethod.Name := 'MainDatasetDeclarationMethod';
    MainDatasetDeclarationMethod.FieldName := 'DeclarationMethod';
    MainDatasetDeclarationMethod.Size := 14;
    MainDatasetDeclarationStatus.SetParentComponent(MainDataset);
    MainDatasetDeclarationStatus.Name := 'MainDatasetDeclarationStatus';
    MainDatasetDeclarationStatus.FieldName := 'DeclarationStatus';
    MainDatasetDeclarationStatus.Size := 11;
    MainDatasetDeclarationId.SetParentComponent(MainDataset);
    MainDatasetDeclarationId.Name := 'MainDatasetDeclarationId';
    MainDatasetDeclarationId.FieldName := 'DeclarationId';
    MainDataSource.Left := 816;
    MainDataSource.Top := 98;
    WebElementActionList1.Left := 856;
    WebElementActionList1.Top := 408;
    ListCloseTimer.Interval := 10000;
    ListCloseTimer.Left := 1056;
    ListCloseTimer.Top := 400;
    RefreshTimer.SetParentComponent(Self);
    RefreshTimer.Name := 'RefreshTimer';
    RefreshTimer.Enabled := False;
    RefreshTimer.Interval := 500;
    SetEvent(RefreshTimer, Self, 'OnTimer', 'RefreshTimerTimer');
    RefreshTimer.Left := 704;
    RefreshTimer.Top := 26;
    WaitForBatchIdTimer.SetParentComponent(Self);
    WaitForBatchIdTimer.Name := 'WaitForBatchIdTimer';
    WaitForBatchIdTimer.Enabled := False;
    SetEvent(WaitForBatchIdTimer, Self, 'OnTimer', 'WaitForBatchIdTimerTimer');
    WaitForBatchIdTimer.Left := 792;
    WaitForBatchIdTimer.Top := 26;
    WaitForBatchDataTimer.SetParentComponent(Self);
    WaitForBatchDataTimer.Name := 'WaitForBatchDataTimer';
    WaitForBatchDataTimer.Enabled := False;
    SetEvent(WaitForBatchDataTimer, Self, 'OnTimer', 'WaitForBatchDataTimerTimer');
    WaitForBatchDataTimer.Left := 984;
    WaitForBatchDataTimer.Top := 34;
    NextRecordTimer.SetParentComponent(Self);
    NextRecordTimer.Name := 'NextRecordTimer';
    NextRecordTimer.Enabled := False;
    NextRecordTimer.Interval := 500;
    SetEvent(NextRecordTimer, Self, 'OnTimer', 'NextRecordTimerTimer');
    NextRecordTimer.Left := 984;
    NextRecordTimer.Top := 122;
    EnableSaveButtonTimer.SetParentComponent(Self);
    EnableSaveButtonTimer.Name := 'EnableSaveButtonTimer';
    EnableSaveButtonTimer.Enabled := False;
    EnableSaveButtonTimer.Interval := 500;
    SetEvent(EnableSaveButtonTimer, Self, 'OnTimer', 'EnableSaveButtonTimerTimer');
    EnableSaveButtonTimer.Left := 1024;
    EnableSaveButtonTimer.Top := 242;
    DonorsDataset.SetParentComponent(Self);
    DonorsDataset.Name := 'DonorsDataset';
    DonorsDataset.AfterOpen := DonorsDatasetAfterOpen;
    DonorsDataset.EntitySetName := 'Donor';
    DonorsDataset.Connection := MainData.DataConnection;
    DonorsDataset.Left := 904;
    DonorsDataset.Top := 98;
    DonorsDatasetId.SetParentComponent(DonorsDataset);
    DonorsDatasetId.Name := 'DonorsDatasetId';
    DonorsDatasetId.FieldName := 'Id';
    DonorsDatasetDateAdded.SetParentComponent(DonorsDataset);
    DonorsDatasetDateAdded.Name := 'DonorsDatasetDateAdded';
    DonorsDatasetDateAdded.FieldName := 'DateAdded';
    DonorsDatasetAddedBy.SetParentComponent(DonorsDataset);
    DonorsDatasetAddedBy.Name := 'DonorsDatasetAddedBy';
    DonorsDatasetAddedBy.FieldName := 'AddedBy';
    DonorsDatasetLastUpdatedBy.SetParentComponent(DonorsDataset);
    DonorsDatasetLastUpdatedBy.Name := 'DonorsDatasetLastUpdatedBy';
    DonorsDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonorsDatasetLastUpdated.SetParentComponent(DonorsDataset);
    DonorsDatasetLastUpdated.Name := 'DonorsDatasetLastUpdated';
    DonorsDatasetLastUpdated.FieldName := 'LastUpdated';
    DonorsDatasetTitle.SetParentComponent(DonorsDataset);
    DonorsDatasetTitle.Name := 'DonorsDatasetTitle';
    DonorsDatasetTitle.FieldName := 'Title';
    DonorsDatasetTitle.Size := 25;
    DonorsDatasetFirstName.SetParentComponent(DonorsDataset);
    DonorsDatasetFirstName.Name := 'DonorsDatasetFirstName';
    DonorsDatasetFirstName.FieldName := 'FirstName';
    DonorsDatasetFirstName.Size := 50;
    DonorsDatasetMiddleName.SetParentComponent(DonorsDataset);
    DonorsDatasetMiddleName.Name := 'DonorsDatasetMiddleName';
    DonorsDatasetMiddleName.FieldName := 'MiddleName';
    DonorsDatasetMiddleName.Size := 50;
    DonorsDatasetLastName.SetParentComponent(DonorsDataset);
    DonorsDatasetLastName.Name := 'DonorsDatasetLastName';
    DonorsDatasetLastName.FieldName := 'LastName';
    DonorsDatasetLastName.Size := 50;
    DonorsDatasetSuffix.SetParentComponent(DonorsDataset);
    DonorsDatasetSuffix.Name := 'DonorsDatasetSuffix';
    DonorsDatasetSuffix.FieldName := 'Suffix';
    DonorsDatasetSuffix.Size := 50;
    DonorsDatasetAdd1.SetParentComponent(DonorsDataset);
    DonorsDatasetAdd1.Name := 'DonorsDatasetAdd1';
    DonorsDatasetAdd1.FieldName := 'Add1';
    DonorsDatasetAdd1.Size := 75;
    DonorsDatasetAdd2.SetParentComponent(DonorsDataset);
    DonorsDatasetAdd2.Name := 'DonorsDatasetAdd2';
    DonorsDatasetAdd2.FieldName := 'Add2';
    DonorsDatasetAdd2.Size := 75;
    DonorsDatasetAdd3.SetParentComponent(DonorsDataset);
    DonorsDatasetAdd3.Name := 'DonorsDatasetAdd3';
    DonorsDatasetAdd3.FieldName := 'Add3';
    DonorsDatasetAdd3.Size := 75;
    DonorsDatasetCity.SetParentComponent(DonorsDataset);
    DonorsDatasetCity.Name := 'DonorsDatasetCity';
    DonorsDatasetCity.FieldName := 'City';
    DonorsDatasetCity.Size := 75;
    DonorsDatasetPostCode.SetParentComponent(DonorsDataset);
    DonorsDatasetPostCode.Name := 'DonorsDatasetPostCode';
    DonorsDatasetPostCode.FieldName := 'PostCode';
    DonorsDatasetPostCode.Size := 15;
    DonorsDatasetEmail.SetParentComponent(DonorsDataset);
    DonorsDatasetEmail.Name := 'DonorsDatasetEmail';
    DonorsDatasetEmail.FieldName := 'Email';
    DonorsDatasetEmail.Size := 75;
    DonorsDatasetMobile.SetParentComponent(DonorsDataset);
    DonorsDatasetMobile.Name := 'DonorsDatasetMobile';
    DonorsDatasetMobile.FieldName := 'Mobile';
    DonorsDatasetMobile.Size := 25;
    DonorsDatasetTelephone.SetParentComponent(DonorsDataset);
    DonorsDatasetTelephone.Name := 'DonorsDatasetTelephone';
    DonorsDatasetTelephone.FieldName := 'Telephone';
    DonorsDatasetTelephone.Size := 25;
    DonorsDatasetMatchHash.SetParentComponent(DonorsDataset);
    DonorsDatasetMatchHash.Name := 'DonorsDatasetMatchHash';
    DonorsDatasetMatchHash.FieldName := 'MatchHash';
    DonorsDatasetMatchHash.Size := 64;
    DonorsDatasetContactByPhone.SetParentComponent(DonorsDataset);
    DonorsDatasetContactByPhone.Name := 'DonorsDatasetContactByPhone';
    DonorsDatasetContactByPhone.FieldName := 'ContactByPhone';
    DonorsDatasetContactByPost.SetParentComponent(DonorsDataset);
    DonorsDatasetContactByPost.Name := 'DonorsDatasetContactByPost';
    DonorsDatasetContactByPost.FieldName := 'ContactByPost';
    DonorsDatasetContactByText.SetParentComponent(DonorsDataset);
    DonorsDatasetContactByText.Name := 'DonorsDatasetContactByText';
    DonorsDatasetContactByText.FieldName := 'ContactByText';
    DonorsDatasetContactByEmail.SetParentComponent(DonorsDataset);
    DonorsDatasetContactByEmail.Name := 'DonorsDatasetContactByEmail';
    DonorsDatasetContactByEmail.FieldName := 'ContactByEmail';
    DonorsDatasetDOB.SetParentComponent(DonorsDataset);
    DonorsDatasetDOB.Name := 'DonorsDatasetDOB';
    DonorsDatasetDOB.FieldName := 'DOB';
    DonorsDatasetHearingStatus.SetParentComponent(DonorsDataset);
    DonorsDatasetHearingStatus.Name := 'DonorsDatasetHearingStatus';
    DonorsDatasetHearingStatus.FieldName := 'HearingStatus';
    DonorsDatasetHearingStatus.Size := 8;
    DonorsDatasetEmailStatus.SetParentComponent(DonorsDataset);
    DonorsDatasetEmailStatus.Name := 'DonorsDatasetEmailStatus';
    DonorsDatasetEmailStatus.FieldName := 'EmailStatus';
    DonorsDatasetEmailStatus.Size := 10;
    DonorsDatasetLatitude.SetParentComponent(DonorsDataset);
    DonorsDatasetLatitude.Name := 'DonorsDatasetLatitude';
    DonorsDatasetLatitude.FieldName := 'Latitude';
    DonorsDatasetLongitude.SetParentComponent(DonorsDataset);
    DonorsDatasetLongitude.Name := 'DonorsDatasetLongitude';
    DonorsDatasetLongitude.FieldName := 'Longitude';
    DonorsDatasetExternalId.SetParentComponent(DonorsDataset);
    DonorsDatasetExternalId.Name := 'DonorsDatasetExternalId';
    DonorsDatasetExternalId.FieldName := 'ExternalId';
    DonorsDatasetExternalId.Size := 64;
    DonorsDatasetCountryCode.SetParentComponent(DonorsDataset);
    DonorsDatasetCountryCode.Name := 'DonorsDatasetCountryCode';
    DonorsDatasetCountryCode.FieldName := 'CountryCode';
    DonorsDatasetCountryCode.Size := 3;
    DonorsDatasetVisualStatus.SetParentComponent(DonorsDataset);
    DonorsDatasetVisualStatus.Name := 'DonorsDatasetVisualStatus';
    DonorsDatasetVisualStatus.FieldName := 'VisualStatus';
    DonorsDatasetVisualStatus.Size := 8;
    DonorsDatasetMobilityStatus.SetParentComponent(DonorsDataset);
    DonorsDatasetMobilityStatus.Name := 'DonorsDatasetMobilityStatus';
    DonorsDatasetMobilityStatus.FieldName := 'MobilityStatus';
    DonorsDatasetMobilityStatus.Size := 8;
    DonorsDatasetSourceType.SetParentComponent(DonorsDataset);
    DonorsDatasetSourceType.Name := 'DonorsDatasetSourceType';
    DonorsDatasetSourceType.FieldName := 'SourceType';
    DonorsDatasetSourceType.Size := 9;
    DonorsDatasetClaimStatus.SetParentComponent(DonorsDataset);
    DonorsDatasetClaimStatus.Name := 'DonorsDatasetClaimStatus';
    DonorsDatasetClaimStatus.FieldName := 'ClaimStatus';
    DonorsDatasetClaimStatus.Size := 19;
    DonorsDatasetCharityTenant.SetParentComponent(DonorsDataset);
    DonorsDatasetCharityTenant.Name := 'DonorsDatasetCharityTenant';
    DonorsDatasetCharityTenant.FieldName := 'CharityTenant';
    DonorsDatasetSponsored.SetParentComponent(DonorsDataset);
    DonorsDatasetSponsored.Name := 'DonorsDatasetSponsored';
    DonorsDatasetSponsored.FieldName := 'Sponsored';
    DonorsDatasetMatchedPerson.SetParentComponent(DonorsDataset);
    DonorsDatasetMatchedPerson.Name := 'DonorsDatasetMatchedPerson';
    DonorsDatasetMatchedPerson.FieldName := 'MatchedPerson';
    DonorsDatasetExternalDonationKind.SetParentComponent(DonorsDataset);
    DonorsDatasetExternalDonationKind.Name := 'DonorsDatasetExternalDonationKind';
    DonorsDatasetExternalDonationKind.FieldName := 'DonationKind';
    DonorsDatasetExternalDonationKind.Size := 30;
    DonorsDatasetExternalDonorKind.SetParentComponent(DonorsDataset);
    DonorsDatasetExternalDonorKind.Name := 'DonorsDatasetExternalDonorKind';
    DonorsDatasetExternalDonorKind.FieldName := 'DonorKind';
    DonorsDatasetExternalDonorKind.Size := 30;
    DonorsDatasetPaymentMethod.SetParentComponent(DonorsDataset);
    DonorsDatasetPaymentMethod.Name := 'DonorsDatasetPaymentMethod';
    DonorsDatasetPaymentMethod.FieldName := 'PaymentMethod';
    DonorsDatasetPaymentMethod.Size := 30;
    DonorsDatasetPaymentMethodNote.SetParentComponent(DonorsDataset);
    DonorsDatasetPaymentMethodNote.Name := 'DonorsDatasetPaymentMethodNote';
    DonorsDatasetPaymentMethodNote.FieldName := 'PaymentMethodNote';
    DonorsDatasetPaymentMethodNote.Size := 75;
    DonorsDatasetOtherDonationKind.SetParentComponent(DonorsDataset);
    DonorsDatasetOtherDonationKind.Name := 'DonorsDatasetOtherDonationKind';
    DonorsDatasetOtherDonationKind.FieldName := 'OtherDonationKind';
    DonorsDatasetOtherDonationKind.Size := 100;
    DonorsDatasetDonorResidence.SetParentComponent(DonorsDataset);
    DonorsDatasetDonorResidence.Name := 'DonorsDatasetDonorResidence';
    DonorsDatasetDonorResidence.FieldName := 'DonorResidence';
    DonorsDatasetDonorResidence.Size := 100;
    DonorsDatasetBankingDate.SetParentComponent(DonorsDataset);
    DonorsDatasetBankingDate.Name := 'DonorsDatasetBankingDate';
    DonorsDatasetBankingDate.FieldName := 'BankingDate';
    DonorsDatasetOrganisationName.SetParentComponent(DonorsDataset);
    DonorsDatasetOrganisationName.Name := 'DonorsDatasetOrganisationName';
    DonorsDatasetOrganisationName.FieldName := 'OrganisationName';
    DonorsDatasetOrganisationName.Size := 250;
    DonorsDatasetDateOfDeath.SetParentComponent(DonorsDataset);
    DonorsDatasetDateOfDeath.Name := 'DonorsDatasetDateOfDeath';
    DonorsDatasetDateOfDeath.FieldName := 'DateOfDeath';
    DonorsDatasetDateOfDeath.DisplayFormat := 'DD/MM/YYYY';
    SearchDonorsDELETE.SetParentComponent(Self);
    SearchDonorsDELETE.Name := 'SearchDonorsDELETE';
    SearchDonorsDELETE.Enabled := False;
    SearchDonorsDELETE.Left := 1040;
    SearchDonorsDELETE.Top := 34;
    ImportDataDataSource.SetParentComponent(Self);
    ImportDataDataSource.Name := 'ImportDataDataSource';
    ImportDataDataSource.Left := 808;
    ImportDataDataSource.Top := 248;
    DonationDefaults.SetParentComponent(Self);
    DonationDefaults.Name := 'DonationDefaults';
    DonationDefaults.EntitySetName := 'DonationDefaults';
    DonationDefaults.Connection := MainData.DataConnection;
    DonationDefaults.Left := 888;
    DonationDefaults.Top := 816;
    DonationDefaultsId.SetParentComponent(DonationDefaults);
    DonationDefaultsId.Name := 'DonationDefaultsId';
    DonationDefaultsId.FieldName := 'Id';
    DonationDefaultsDateAdded.SetParentComponent(DonationDefaults);
    DonationDefaultsDateAdded.Name := 'DonationDefaultsDateAdded';
    DonationDefaultsDateAdded.FieldName := 'DateAdded';
    DonationDefaultsAddedBy.SetParentComponent(DonationDefaults);
    DonationDefaultsAddedBy.Name := 'DonationDefaultsAddedBy';
    DonationDefaultsAddedBy.FieldName := 'AddedBy';
    DonationDefaultsLastUpdatedBy.SetParentComponent(DonationDefaults);
    DonationDefaultsLastUpdatedBy.Name := 'DonationDefaultsLastUpdatedBy';
    DonationDefaultsLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonationDefaultsLastUpdated.SetParentComponent(DonationDefaults);
    DonationDefaultsLastUpdated.Name := 'DonationDefaultsLastUpdated';
    DonationDefaultsLastUpdated.FieldName := 'LastUpdated';
    DonationDefaultsDonorId.SetParentComponent(DonationDefaults);
    DonationDefaultsDonorId.Name := 'DonationDefaultsDonorId';
    DonationDefaultsDonorId.FieldName := 'DonorId';
    DonationDefaultsDonationKind.SetParentComponent(DonationDefaults);
    DonationDefaultsDonationKind.Name := 'DonationDefaultsDonationKind';
    DonationDefaultsDonationKind.FieldName := 'DonationKind';
    DonationDefaultsDonationKind.Size := 30;
    DonationDefaultsUsualDayOfMonth.SetParentComponent(DonationDefaults);
    DonationDefaultsUsualDayOfMonth.Name := 'DonationDefaultsUsualDayOfMonth';
    DonationDefaultsUsualDayOfMonth.FieldName := 'UsualDayOfMonth';
    DonationDefaultsAmount.SetParentComponent(DonationDefaults);
    DonationDefaultsAmount.Name := 'DonationDefaultsAmount';
    DonationDefaultsAmount.FieldName := 'Amount';
    DonationDefaultsPaymentMethod.SetParentComponent(DonationDefaults);
    DonationDefaultsPaymentMethod.Name := 'DonationDefaultsPaymentMethod';
    DonationDefaultsPaymentMethod.FieldName := 'PaymentMethod';
    DonationDefaultsAnalysisCode1.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode1.Name := 'DonationDefaultsAnalysisCode1';
    DonationDefaultsAnalysisCode1.FieldName := 'AnalysisCode1';
    DonationDefaultsAnalysisCode1.Size := 75;
    DonationDefaultsAnalysisCode2.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode2.Name := 'DonationDefaultsAnalysisCode2';
    DonationDefaultsAnalysisCode2.FieldName := 'AnalysisCode2';
    DonationDefaultsAnalysisCode2.Size := 75;
    DonationDefaultsAnalysisCode3.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode3.Name := 'DonationDefaultsAnalysisCode3';
    DonationDefaultsAnalysisCode3.FieldName := 'AnalysisCode3';
    DonationDefaultsAnalysisCode3.Size := 75;
    DonationDefaultsBankingReference.SetParentComponent(DonationDefaults);
    DonationDefaultsBankingReference.Name := 'DonationDefaultsBankingReference';
    DonationDefaultsBankingReference.FieldName := 'BankingReference';
    DonationDefaultsBankingReference.Size := 255;
    DonationDefaultsOtherDonationKind.SetParentComponent(DonationDefaults);
    DonationDefaultsOtherDonationKind.Name := 'DonationDefaultsOtherDonationKind';
    DonationDefaultsOtherDonationKind.FieldName := 'OtherDonationKind';
    DonationDefaultsOtherDonationKind.Size := 255;
    LookupsDataset.SetParentComponent(Self);
    LookupsDataset.Name := 'LookupsDataset';
    LookupsDataset.AfterOpen := LookupsDatasetAfterOpen;
    LookupsDataset.EntitySetName := 'ImportDonation';
    LookupsDataset.Connection := MainData.DataConnection;
    LookupsDataset.Left := 440;
    LookupsDataset.Top := 98;
    AnalysisCode1.SetParentComponent(LookupsDataset);
    AnalysisCode1.Name := 'AnalysisCode1';
    AnalysisCode1.FieldName := 'AnalysisCode1';
    AnalysisCode1.Size := 64;
    AnalysisCode2.SetParentComponent(LookupsDataset);
    AnalysisCode2.Name := 'AnalysisCode2';
    AnalysisCode2.FieldName := 'AnalysisCode2';
    AnalysisCode2.Size := 64;
    LookupsDatasetBankingReference.SetParentComponent(LookupsDataset);
    LookupsDatasetBankingReference.Name := 'LookupsDatasetBankingReference';
    LookupsDatasetBankingReference.FieldName := 'BankingReference';
    LookupsDataSource.SetParentComponent(Self);
    LookupsDataSource.Name := 'LookupsDataSource';
    LookupsDataSource.DataSet := LookupsDataset;
    LookupsDataSource.Left := 440;
    LookupsDataSource.Top := 160;
  finally
    MessageLabel.AfterLoadDFMValues;
    DonationsData.AfterLoadDFMValues;
    ErrorMessageTransactionDate.AfterLoadDFMValues;
    lbBatchTotal.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataTable.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    SearchButton.AfterLoadDFMValues;
    MergeButton.AfterLoadDFMValues;
    ClearButton.AfterLoadDFMValues;
    MessageDialog.AfterLoadDFMValues;
    DuplicateDialog.AfterLoadDFMValues;
    CountryList.AfterLoadDFMValues;
    DeleteDonation.AfterLoadDFMValues;
    DeleteDonor.AfterLoadDFMValues;
    DonorSearchCombo.AfterLoadDFMValues;
    TitleEdit.AfterLoadDFMValues;
    FirstNameEdit.AfterLoadDFMValues;
    LastNameEdit.AfterLoadDFMValues;
    Add1Edit.AfterLoadDFMValues;
    Add2Edit.AfterLoadDFMValues;
    Add3Edit.AfterLoadDFMValues;
    CityEdit.AfterLoadDFMValues;
    PostCodeEdit.AfterLoadDFMValues;
    AmountEdit.AfterLoadDFMValues;
    DonationDateEdit.AfterLoadDFMValues;
    SponsoredEdit.AfterLoadDFMValues;
    DonationKindCombo.AfterLoadDFMValues;
    OtherDonationKindEdit.AfterLoadDFMValues;
    DonorKindCombo.AfterLoadDFMValues;
    PaymentMethodNoteEdit.AfterLoadDFMValues;
    DonorClaimStatusCombo.AfterLoadDFMValues;
    OrganisationNameEdit.AfterLoadDFMValues;
    PaymentMethodCombo.AfterLoadDFMValues;
    ListWaitMessage.AfterLoadDFMValues;
    DeclarationCombo.AfterLoadDFMValues;
    DonationClaimStatus.AfterLoadDFMValues;
    BankingDateEdit.AfterLoadDFMValues;
    CommentMemo.AfterLoadDFMValues;
    AnalysisCode1Combo.AfterLoadDFMValues;
    AnalysisCode2Combo.AfterLoadDFMValues;
    DonorDeclarationButton.AfterLoadDFMValues;
    BankingReference2Edit.AfterLoadDFMValues;
    BankingReferenceCombo.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetTitle.AfterLoadDFMValues;
    MainDatasetFirstName.AfterLoadDFMValues;
    MainDatasetMiddleName.AfterLoadDFMValues;
    MainDatasetLastName.AfterLoadDFMValues;
    MainDatasetSuffix.AfterLoadDFMValues;
    MainDatasetAdd1.AfterLoadDFMValues;
    MainDatasetAdd2.AfterLoadDFMValues;
    MainDatasetAdd3.AfterLoadDFMValues;
    MainDatasetCity.AfterLoadDFMValues;
    MainDatasetPostCode.AfterLoadDFMValues;
    MainDatasetEmail.AfterLoadDFMValues;
    MainDatasetMobile.AfterLoadDFMValues;
    MainDatasetTelephone.AfterLoadDFMValues;
    MainDatasetMatchHash.AfterLoadDFMValues;
    MainDatasetContactByPhone.AfterLoadDFMValues;
    MainDatasetContactedByPost.AfterLoadDFMValues;
    MainDatasetContactByText.AfterLoadDFMValues;
    MainDatasetContactByEmail.AfterLoadDFMValues;
    MainDatasetDOB.AfterLoadDFMValues;
    MainDatasetHearingStatus.AfterLoadDFMValues;
    MainDatasetEmailStatus.AfterLoadDFMValues;
    MainDatasetLatitude.AfterLoadDFMValues;
    MainDatasetLongitude.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetCountryCode.AfterLoadDFMValues;
    MainDatasetVisualStatus.AfterLoadDFMValues;
    MainDatasetMobilityStatus.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetImportState.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetImportBatchId.AfterLoadDFMValues;
    MainDatasetSponsored.AfterLoadDFMValues;
    MainDatasetDonationDate.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetExternalDonationId.AfterLoadDFMValues;
    MainDatasetMatchedPerson.AfterLoadDFMValues;
    MainDatasetExternalDonationKind.AfterLoadDFMValues;
    MainDatasetExternalDonorKind.AfterLoadDFMValues;
    MainDatasetPaymentMethod.AfterLoadDFMValues;
    MainDatasetPaymentMethodNote.AfterLoadDFMValues;
    MainDatasetOtherDonationKind.AfterLoadDFMValues;
    MainDatasetDonorResidence.AfterLoadDFMValues;
    MainDatasetBankingDate.AfterLoadDFMValues;
    MainDatasetOrganisationName.AfterLoadDFMValues;
    MainDatasetDonationClaimStatus.AfterLoadDFMValues;
    MainDatasetComment.AfterLoadDFMValues;
    MainDatasetAnalysisCode1.AfterLoadDFMValues;
    MainDatasetAnalysisCode2.AfterLoadDFMValues;
    MainDatasetAnalysisCode3.AfterLoadDFMValues;
    MainDatasetBankingReference.AfterLoadDFMValues;
    MainDatasetBankingReference2.AfterLoadDFMValues;
    MainDatasetDeclarationDateSigned.AfterLoadDFMValues;
    MainDatasetDeclarationDateStarted.AfterLoadDFMValues;
    MainDatasetDeclarationClaimCoverage.AfterLoadDFMValues;
    MainDatasetDeclarationMethod.AfterLoadDFMValues;
    MainDatasetDeclarationStatus.AfterLoadDFMValues;
    MainDatasetDeclarationId.AfterLoadDFMValues;
    MainDataSource.AfterLoadDFMValues;
    WebElementActionList1.AfterLoadDFMValues;
    ListCloseTimer.AfterLoadDFMValues;
    RefreshTimer.AfterLoadDFMValues;
    WaitForBatchIdTimer.AfterLoadDFMValues;
    WaitForBatchDataTimer.AfterLoadDFMValues;
    NextRecordTimer.AfterLoadDFMValues;
    EnableSaveButtonTimer.AfterLoadDFMValues;
    DonorsDataset.AfterLoadDFMValues;
    DonorsDatasetId.AfterLoadDFMValues;
    DonorsDatasetDateAdded.AfterLoadDFMValues;
    DonorsDatasetAddedBy.AfterLoadDFMValues;
    DonorsDatasetLastUpdatedBy.AfterLoadDFMValues;
    DonorsDatasetLastUpdated.AfterLoadDFMValues;
    DonorsDatasetTitle.AfterLoadDFMValues;
    DonorsDatasetFirstName.AfterLoadDFMValues;
    DonorsDatasetMiddleName.AfterLoadDFMValues;
    DonorsDatasetLastName.AfterLoadDFMValues;
    DonorsDatasetSuffix.AfterLoadDFMValues;
    DonorsDatasetAdd1.AfterLoadDFMValues;
    DonorsDatasetAdd2.AfterLoadDFMValues;
    DonorsDatasetAdd3.AfterLoadDFMValues;
    DonorsDatasetCity.AfterLoadDFMValues;
    DonorsDatasetPostCode.AfterLoadDFMValues;
    DonorsDatasetEmail.AfterLoadDFMValues;
    DonorsDatasetMobile.AfterLoadDFMValues;
    DonorsDatasetTelephone.AfterLoadDFMValues;
    DonorsDatasetMatchHash.AfterLoadDFMValues;
    DonorsDatasetContactByPhone.AfterLoadDFMValues;
    DonorsDatasetContactByPost.AfterLoadDFMValues;
    DonorsDatasetContactByText.AfterLoadDFMValues;
    DonorsDatasetContactByEmail.AfterLoadDFMValues;
    DonorsDatasetDOB.AfterLoadDFMValues;
    DonorsDatasetHearingStatus.AfterLoadDFMValues;
    DonorsDatasetEmailStatus.AfterLoadDFMValues;
    DonorsDatasetLatitude.AfterLoadDFMValues;
    DonorsDatasetLongitude.AfterLoadDFMValues;
    DonorsDatasetExternalId.AfterLoadDFMValues;
    DonorsDatasetCountryCode.AfterLoadDFMValues;
    DonorsDatasetVisualStatus.AfterLoadDFMValues;
    DonorsDatasetMobilityStatus.AfterLoadDFMValues;
    DonorsDatasetSourceType.AfterLoadDFMValues;
    DonorsDatasetClaimStatus.AfterLoadDFMValues;
    DonorsDatasetCharityTenant.AfterLoadDFMValues;
    DonorsDatasetSponsored.AfterLoadDFMValues;
    DonorsDatasetMatchedPerson.AfterLoadDFMValues;
    DonorsDatasetExternalDonationKind.AfterLoadDFMValues;
    DonorsDatasetExternalDonorKind.AfterLoadDFMValues;
    DonorsDatasetPaymentMethod.AfterLoadDFMValues;
    DonorsDatasetPaymentMethodNote.AfterLoadDFMValues;
    DonorsDatasetOtherDonationKind.AfterLoadDFMValues;
    DonorsDatasetDonorResidence.AfterLoadDFMValues;
    DonorsDatasetBankingDate.AfterLoadDFMValues;
    DonorsDatasetOrganisationName.AfterLoadDFMValues;
    DonorsDatasetDateOfDeath.AfterLoadDFMValues;
    SearchDonorsDELETE.AfterLoadDFMValues;
    ImportDataDataSource.AfterLoadDFMValues;
    DonationDefaults.AfterLoadDFMValues;
    DonationDefaultsId.AfterLoadDFMValues;
    DonationDefaultsDateAdded.AfterLoadDFMValues;
    DonationDefaultsAddedBy.AfterLoadDFMValues;
    DonationDefaultsLastUpdatedBy.AfterLoadDFMValues;
    DonationDefaultsLastUpdated.AfterLoadDFMValues;
    DonationDefaultsDonorId.AfterLoadDFMValues;
    DonationDefaultsDonationKind.AfterLoadDFMValues;
    DonationDefaultsUsualDayOfMonth.AfterLoadDFMValues;
    DonationDefaultsAmount.AfterLoadDFMValues;
    DonationDefaultsPaymentMethod.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode1.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode2.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode3.AfterLoadDFMValues;
    DonationDefaultsBankingReference.AfterLoadDFMValues;
    DonationDefaultsOtherDonationKind.AfterLoadDFMValues;
    LookupsDataset.AfterLoadDFMValues;
    AnalysisCode1.AfterLoadDFMValues;
    AnalysisCode2.AfterLoadDFMValues;
    LookupsDatasetBankingReference.AfterLoadDFMValues;
    LookupsDataSource.AfterLoadDFMValues;
  end;
end;

end.

